import type { Catalogue } from "../i18n";

export const JA: Catalogue = {
  "failed": "失敗",
  "saving": "保存中",
  "waiting": "待機中",
  "today": "今日",
  "yesterday": "昨日",
  "{days}d": "{days}日",
  "{weeks}w": "{weeks}週",
  "unlabeled": "名前なし",
  "clip": "クリップ",
  "untagged": "タグなし",
  "loading more": "さらに読み込み中",
  "that's all {count}": "これで全部、{count}件",
  "shuffled": "シャッフルしました",
  "nothing to show": "表示するものがありません",
  "chi is looking again": "chiがもう一度見ています",
  "chi is looking at this one next": "次にchiがこれを見ます",
  "could not index that ref": "その資料をインデックスできませんでした",
  "details": "詳細",
  "clips are not described, write your own": "クリップは説明されません。自分で書いてね",
  "chi left this one ({reason}), write your own": "chiはこれをスキップしました（{reason}）。自分で書いてね",
  "chi is looking at this…": "chiが見ています…",
  "not described yet, write your own or tap spark": "まだ説明なし。自分で書くか、スパークをタップ",
  "saved": "保存済み",
  "could not save the description": "説明を保存できませんでした",
  "chi skips clips": "chiはクリップをスキップします",
  "described": "説明済み",
  "chi is looking": "chiが見ています",
  "skipped": "スキップ",
  "waiting on chi": "chiを待っています",
  "tagging {done}/{total} · {left} left": "タグ付け中 {done}/{total} · 残り{left}",
  "tagged {done}/{total} · {left} left": "タグ付け済み {done}/{total} · 残り{left}",
  "all {total} tagged": "{total}件すべてタグ付け済み",
  "{shown} of {total}": "{shown} / {total}",
  "{count} adding": "{count}件追加中",
  "{count} failed": "{count}件失敗",
  "{count} to describe": "説明待ち{count}件",
  "busy": "処理中",
  "tag": "タグ",
  "tap + to add pictures, drop files here, or use + ref in chrome": "+をタップして画像を追加、ここにファイルをドロップ、またはchromeの+ refを使ってね",
  "every ref already has your note": "すべての資料にメモがあります",
  "nothing matches": "一致するものなし",
  "could not load references": "資料を読み込めませんでした",
  "video": "動画",
  "all described": "すべて説明済み",
  "could not read that file": "そのファイルを読めませんでした",
  "nothing usable there": "使えるものがありません",
  "adding {count}": "{count}件追加中",
  "could not import that file": "そのファイルをインポートできませんでした",
  "showing {tag}": "{tag}を表示中",
  "chi is tagging {count} refs": "chiが{count}件の資料にタグ付け中",
  "every ref is tagged": "すべての資料がタグ付け済み",
  "could not start tagging": "タグ付けを開始できませんでした",
  "delete this reference?": "この資料を削除しますか？",
  "ref saved": "資料を保存しました",
  "ref save failed": "資料の保存に失敗しました",
  "tagging done": "タグ付け完了",
  "mode": "モード",
  "tools": "ツール",
  "Tools": "ツール",
  "Talk to Chi": "Chiと話す",
  "mode tuner, drag or tap a station": "モードチューナー、ドラッグかステーションをタップ",
  "web": "ウェブ",
  "Tool": "ツール",
  "Chi · direct line": "Chi · 直通",
  "{name}'s {what} · read only": "{name}の{what} · 閲覧のみ",
  "could not open a print sheet": "印刷シートを開けませんでした",
  "never": "なし",
  "could not shrink that picture": "その画像を縮小できませんでした",
  "could not read that picture": "その画像を読み込めませんでした",
  "chix is processing": "chixが処理中",
  "What should I work on next?": "次は何に取り組むべき？",
  "nothing yet": "まだ何もありません",
  "where it came from": "どこから？",
  "rent, phone…": "家賃、電話…",
  "what was it": "何に使った？",
  "mine": "自分の",
  "{name}'s": "{name}の",
  "added to {name}'s budget": "{name}の予算に追加しました",
  "added to your budget": "あなたの予算に追加しました",
  "couldn't add that": "追加できませんでした",
  "login with discord": "discordでログインしてね",
  "a minipi": "あるminipi",
  "{who} says": "{who}より",
  "{who} · art tip": "{who} · お絵描きヒント",
  "pings": "通知",
  "Late shift, {name}.": "遅番だね、{name}。",
  "Morning, {name}.": "おはよう、{name}。",
  "Ready when you are, {name}.": "いつでもどうぞ、{name}。",
  "Evening, {name}.": "こんばんは、{name}。",
  "signal": "シグナル",
  "sweet": "スイート",
  "edge": "エッジ",
  "retro": "レトロ",
  "dark fog, film grain and chi's cyan": "暗い霧、フィルムグレイン、chiのシアン",
  "pale daytime fog, ink and deep teal": "淡い昼の霧、インク、深いティール",
  "silent hill ash and an orange coal": "サイレントヒルの灰とオレンジの炭火",
  "deep water, teal fog, a sonar ping": "深い水、ティールの霧、ソナーの音",
  "rose paper and a hot pink signal": "ローズの紙とホットピンクのシグナル",
  "peach cream and a coral signal": "ピーチクリームとコーラルのシグナル",
  "mint milk with strawberry pink": "ミントミルクといちごピンク",
  "magical girl night, violet fog, bubblegum pink": "魔法少女の夜、紫の霧、バブルガムピンク",
  "midnight sky in periwinkle and pink": "ペリウィンクルとピンクの真夜中の空",
  "the otherworld: rust black and blood red": "裏世界：錆びた黒と血の赤",
  "night city chrome, warning yellow, red glitch": "夜の街のクローム、警告イエロー、赤いグリッチ",
  "bruise purple fog and acid lime": "あざ色の紫の霧とアシッドライム",
  "pure black and white, no mercy": "純粋な白黒、容赦なし",
  "green crt, memory card manager at 2am": "緑のCRT、深夜2時のメモリーカード管理画面",
  "amber crt terminal, warm glow": "アンバーのCRT端末、あたたかい光",
  "cream sketch paper and flipnote orange": "クリーム色のスケッチ用紙とうごメモのオレンジ",
  "grey console, blue memory card screen": "グレーの本体、青いメモリーカード画面",
  "four shades of handheld green": "携帯ゲーム機の4色の緑",
  "none": "なし",
  "scanlines": "走査線",
  "grid": "方眼",
  "dots": "ドット",
  "notebook": "ノート",
  "checker": "チェッカー",
  "crosshair": "十字",
  "sparkles": "きらきら",
  "hazard": "警告",
  "starry sky": "星空",
  "falling leaves": "落ち葉",
  "sakura petals": "桜の花びら",
  "snow": "雪",
  "rain": "雨",
  "fireflies": "ホタル",
  "moves gently, stays still with calm motion": "ゆっくり動きます。穏やかな動きでは静止します",
  "pattern on": "パターンを適用しました",
  "theme on": "テーマを適用しました",
  "bottom": "下",
  "top": "上",
  "one clipped corner, the original look": "角をひとつ欠いた、元のルック",
  "square corners everywhere": "どこも四角い角",
  "gently rounded": "やわらかい丸み",
  "very round, like a handheld menu": "とても丸い、携帯ゲーム機のメニューみたい",
  "the original: Rajdhani titles, pixel labels": "オリジナル：Rajdhani のタイトルとピクセルのラベル",
  "your device's own system font": "端末の標準フォント",
  "easy to read": "読みやすい",
  "Atkinson Hyperlegible, made for low vision": "Atkinson Hyperlegible、弱視の人向け",
  "dyslexia friendly": "ディスレクシア向け",
  "OpenDyslexic, weighted letter bottoms": "OpenDyslexic、字の下が重い",
  "rounded": "丸ゴシック",
  "Fredoka, soft and friendly": "Fredoka、やわらかくて親しみやすい",
  "Lora titles and text": "タイトルも本文も Lora",
  "Space Mono everywhere": "どこも Space Mono",
  "typewriter": "タイプライター",
  "Special Elite, inky and uneven": "Special Elite、インクがにじんだ不揃いな字",
  "Caveat titles, Patrick Hand text": "タイトルは Caveat、本文は Patrick Hand",
  "DotGothic16, a psx menu face": "DotGothic16、psx のメニュー書体",
  "VT323, a green screen console": "VT323、緑画面のコンソール",
  "arcade": "アーケード",
  "Press Start 2P titles, pixel text": "タイトルは Press Start 2P、本文はピクセル",
  "sci-fi": "SF",
  "Orbitron titles over the original labels": "タイトルは Orbitron、ラベルはそのまま",
  "panels you can see through, with a blur": "透けて見えるパネル、ぼかし付き",
  "half see through": "半透明",
  "whatever the theme does": "テーマに任せる",
  "fully opaque, easiest to read over a pattern": "完全に不透明、模様の上でいちばん読みやすい",
  "about 820 px of content": "コンテンツ幅は約 820 px",
  "about 1040 px of content": "コンテンツ幅は約 1040 px",
  "about 1360 px of content": "コンテンツ幅は約 1360 px",
  "use the whole screen": "画面いっぱいに使う",
  "centred": "中央",
  "content in the middle of the screen": "コンテンツを画面の中央に",
  "content next to the menu, spare room on the right": "コンテンツをメニューの隣に、右側は空ける",
  "compact": "コンパクト",
  "tighter gaps, more on screen": "間隔を詰めて、たくさん表示",
  "the original spacing": "元の間隔",
  "roomy": "ゆったり",
  "extra air around everything": "まわりにたっぷり余白",
  "pages sharpen into view": "ページがぼけからくっきり現れる",
  "a plain fade": "ふつうのフェード",
  "pages rise into place": "ページが下からせり上がる",
  "pages simply appear": "ページがそのまま出る",
  "barely there outlines": "ほとんど見えない輪郭",
  "the original": "オリジナル",
  "stronger outlines": "はっきりした輪郭",
  "menu on the left": "メニューを左に",
  "menu on the right": "メニューを右に",
  "radio dock at the bottom of the screen": "ラジオドックを画面の下に",
  "radio dock at the top of the screen": "ラジオドックを画面の上に",
  "brighter text and stronger lines everywhere": "文字をより明るく、線をより強く",
  "a thick ring on whatever the keyboard has selected": "キーボードで選んでいるものに太い輪を表示",
  "loose": "ゆるめ",
  "more space between letters, words and lines": "文字、単語、行の間隔を広げる",
  "moving speckle over everything": "全体に動く粒子",
  "the slow drifting haze behind the pages": "ページの奥をゆっくり漂うもや",
  "pattern strength": "模様の強さ",
  "how strong the background pattern is, needs a pattern": "背景の模様の濃さ、模様が必要",
  "dark edges of the screen": "画面の端を暗く",
  "makes everything bigger or smaller at once": "すべてを一度に大きく、または小さく",
  "easy reading": "読みやすさ重視",
  "big, clear text and strong contrast": "大きくてはっきりした文字、強いコントラスト",
  "cream paper, OpenDyslexic, calm": "クリーム色の紙、OpenDyslexic、落ち着いた雰囲気",
  "feel and access": "使い心地とアクセシビリティ",
  "contrast": "コントラスト",
  "spacing": "間隔",
  "button": "ボタン",
  "put back": "元に戻しました",
  "one tap sets the theme, pattern and the look below. yours only, it saves as you": "タップひとつでテーマ、模様、下のルックが決まる。あなた専用で、あなたとして保存される",
  "reset everything": "すべてリセット",
  "put the whole look back to chi signal?": "ルック全体を chi signal に戻しますか？",
  "back to chi signal": "chi signal に戻しました",
  "nothing saved yet. set things up the way you like, name it and save it here": "まだ保存はありません。好きなように整えて、名前をつけてここに保存しよう",
  "look deleted": "ルックを削除しました",
  "your colours": "あなたの色",
  "the colour of highlights, selected buttons and the glow. it sits on top of any theme": "ハイライト、選択中のボタン、光の色。どのテーマにも重ねられる",
  "background colour": "背景色",
  "your own screen colour instead of the theme's. text and contrast follow on their own": "テーマの代わりに自分で選ぶ画面の色。文字とコントラストは自動で合わせる",
  "switch themes by itself when this device goes light or dark": "この端末がライト／ダークに切り替わるとテーマも自動で切り替える",
  "off keeps the theme you pick above all day": "オフなら、上で選んだテーマを一日中使う",
  "in light mode": "ライトモードのとき",
  "in dark mode": "ダークモードのとき",
  "how panels, buttons and cards are shaped": "パネル、ボタン、カードの形",
  "the typeface for titles, labels and text. every one is bundled, nothing is downloaded from outside": "タイトル、ラベル、本文の書体。すべて内蔵で、外部からは何もダウンロードしない",
  "panel glass": "パネルのガラス",
  "how see-through panels are over the background": "背景に対するパネルの透け具合",
  "outlines": "輪郭",
  "how strong the thin lines around things are": "ものの周りの細い線の強さ",
  "off writes labels in normal lower case, easier to read": "オフなら、ラベルは普通の小文字で表示。読みやすい",
  "background effects": "背景エフェクト",
  "film grain and fog are switched off on this device, so those two sliders have nothing to move": "この端末ではフィルムグレインとフォグがオフなので、その2つのスライダーは効きません",
  "turn them on": "オンにする",
  "grain and fog on": "グレインとフォグをオンにしました",
  "off on this device, turn it on above": "この端末ではオフ。上でオンにしてね",
  "pick a pattern above and this will change how strong it is": "上で模様を選ぶと、この設定で濃さを変えられる",
  "grain and fog on this device": "この端末のグレインとフォグ",
  "this switch is for this browser only. use it to calm a busy screen or a slow device": "このスイッチはこのブラウザだけ。ごちゃごちゃした画面や遅い端末を落ち着かせたいときに",
  "how wide the page content gets. it only shows on screens wider than the setting, so on a phone nothing changes": "ページの内容の幅。設定より広い画面でだけ効くので、スマホでは変わりません",
  "page position": "ページの位置",
  "where the content sits on wide screens": "広い画面でのコンテンツの位置",
  "how close or far apart things sit": "ものどうしの間隔の広さ",
  "menu side, tablets and computers": "メニューの側、タブレットとパソコン",
  "which side the menu with the dial sits on, on screens wider than 900 px": "ダイヤルつきメニューを置く側。幅 900 px を超える画面で有効",
  "dock position, phones": "ドックの位置、スマホ",
  "where the radio dock sits on phones and portrait tablets": "スマホと縦向きタブレットでのラジオドックの位置",
  "the motion as you switch pages": "ページを切り替えるときの動き",
  "size and comfort": "サイズと快適さ",
  "brighter text and stronger lines": "文字をより明るく、線をより強く",
  "keyboard focus ring": "キーボードのフォーカスリング",
  "how clearly the selected control is marked when you use the keyboard": "キーボード操作時に選択中の部品をどれだけはっきり示すか",
  "text spacing": "文字の間隔",
  "more room between letters, words and lines, kinder on tired eyes": "文字、単語、行の間隔を広げて、疲れた目にやさしく",
  "turn off the quick flicker when a page opens": "ページを開くときの一瞬のちらつきをオフにする",
  "stops the fog, falling pieces and most movement on this device": "この端末で、フォグ、降ってくる飾り、ほとんどの動きを止める",
  "this device only": "この端末だけ",
  "a short beep when you press a button, like a console menu": "ボタンを押すと短いビープ音、ゲーム機のメニューみたいに",
  "sounds off": "サウンドをオフにしました",
  "sounds on": "サウンドをオンにしました",
  "tap effect": "タップエフェクト",
  "what appears where you touch the screen": "画面をタッチした場所に出るもの",
  "tap effect off": "タップエフェクトをオフにしました",
  "tap effect on": "タップエフェクトをオンにしました",
  "put this page back": "このページを元に戻す",
  "chip": "チップ",
  "preview": "プレビュー",
  "the quick brown fox jumps over the lazy dog": "いろはにほへと ちりぬるを",
  "look settings": "ルックの設定",
  "a faint pattern behind the pages. the animated ones stay still with calm motion": "ページの奥にうっすら模様。動く模様は「落ち着いた動き」だと止まる",
  "left side": "左側",
  "right side": "右側",
  "one tap sets the theme, pattern and everything below. yours only, it saves as you": "ワンタップでテーマ・パターン・下のすべてが切り替わります。あなただけのもので、あなたとして保存されます",
  "your looks": "保存した見た目",
  "delete this look?": "この見た目を削除しますか？",
  "delete this look": "この見た目を削除",
  "name this look": "この見た目に名前をつける",
  "save current look": "今の見た目を保存",
  "surprise me": "おまかせ",
  "reset look": "見た目をリセット",
  "put the look back to chi signal?": "見た目をchi signalに戻しますか？",
  "my look": "マイ見た目",
  "look code": "見た目コード",
  "copy my code": "自分のコードをコピー",
  "use this code": "このコードを使う",
  "button sounds": "ボタンの音",
  "where you tap": "タップした場所",
  "the theme's own": "テーマのまま",
  "pick any colour": "好きな色を選ぶ",
  "that is the most looks you can keep, delete one first": "保存できる見た目はここまでです。先にひとつ削除してください",
  "look saved": "見た目を保存しました",
  "share a look": "見た目をシェア",
  "copy your code and send it to anyone. paste theirs here and press use to wear it": "コードをコピーして誰にでも送れます。相手のコードをここに貼って「使う」を押すと適用されます",
  "code copied": "コードをコピーしました",
  "code selected, copy it by hand": "コードを選択しました。手動でコピーしてください",
  "that is not a look code": "見た目コードではありません",
  "look on": "見た目を適用しました",
  "rolled a new look": "新しい見た目をつくりました",
  "look reset": "見た目をリセットしました",
  "this device": "この端末",
  "sound and taps are kept on this browser only, grain and calm motion are above": "音とタップはこのブラウザだけに保存されます。粒子と控えめな動きは上にあります",
  "colours": "色",
  "an accent over any theme, and an optional background of your own. text and tone follow on their own": "どのテーマにも重ねられるアクセントと、お好みで自分の背景色。文字色と明るさは自動で合います",
  "shape and type": "かたちと文字",
  "accent": "アクセント",
  "corners": "角",
  "font": "フォント",
  "panels": "パネル",
  "capital letters on labels": "ラベルを大文字にする",
  "atmosphere": "雰囲気",
  "how much fog, grain and pattern sit behind everything. grain and fog also need the switch below": "フォグ・粒子・パターンを背景にどれだけ重ねるか。粒子とフォグは下のスイッチもオンにしてください",
  "layout and motion": "レイアウトと動き",
  "page width": "ページの幅",
  "rail side, on tablets and desktops": "レールの位置（タブレットとデスクトップ）",
  "when a page opens": "ページを開くとき",
  "station worlds": "ステーションの世界観",
  "each station gets its own colour, moving backdrop and a title that locks in when a page opens": "ステーションごとに色と動く背景があり、ページを開くとタイトルが決まります",
  "tilt and magnetic": "傾きと吸着",
  "tiles lean toward your finger or pointer and main buttons pull toward the cursor": "タイルが指やポインタの方へ傾き、主なボタンがカーソルに吸い寄せられます",
  "glitch on page titles": "ページタイトルのグリッチ",
  "day and night": "昼と夜",
  "switch themes with this device's light or dark setting": "この端末のライト／ダーク設定に合わせてテーマを切り替えます",
  "follow the device": "端末に合わせる",
  "light mode": "ライトモード",
  "dark mode": "ダークモード",
  "cut": "カット",
  "sharp": "シャープ",
  "round": "まる",
  "clean": "すっきり",
  "pixel": "ドット",
  "handwritten": "手書き",
  "clear glass": "透明ガラス",
  "frosted": "すりガラス",
  "theme": "テーマ",
  "solid": "ベタ",
  "narrow": "せまい",
  "full": "全幅",
  "blur in": "ぼかしで表示",
  "fade": "フェード",
  "slide up": "上にスライド",
  "faint": "うすい",
  "bold": "くっきり",
  "right": "右",
  "film grain": "フィルムグレイン",
  "pattern": "パターン",
  "vignette": "ビネット",
  "interface size": "画面の大きさ",
  "blip": "ピッ",
  "click": "カチッ",
  "ripple": "波紋",
  "spark": "火花",
  "chi signal": "chi signal",
  "the original, untouched": "オリジナルそのまま",
  "silent hill": "サイレントヒル",
  "ember, heavy fog and grain": "エンバー、濃いフォグと粒子",
  "flipnote": "フリップノート",
  "sketch paper, handwriting, soft corners": "スケッチ用紙、手書き、やわらかい角",
  "memory card": "メモリーカード",
  "psx grey, pixel type, sharp": "psxグレー、ドット文字、シャープ",
  "magical girl": "まほうしょうじょ",
  "lilac night, sparkles, round": "ライラックの夜、きらきら、まる",
  "dsi menu": "dsiメニュー",
  "glossy white, rounded, clean": "つやのある白、まるみ、すっきり",
  "terminal": "ターミナル",
  "green crt, monospace, no frills": "緑のCRT、等幅、飾りなし",
  "the rain": "ザ・レイン",
  "code rain on black": "黒の上のコードの雨",
  "night city": "ナイトシティ",
  "warning yellow, hazard stripes": "警告イエロー、ハザードストライプ",
  "cozy afternoon": "まったり午後",
  "peach cream and falling petals": "ピーチクリームと舞い散る花びら",
  "midnight forest": "真夜中の森",
  "moss and fireflies": "苔とホタル",
  "mall soft": "モール・ソフト",
  "vapor pink and cyan edge": "ベイパーピンクとシアンの縁",
  "drafting table": "製図台",
  "blueprint, grid and mono": "青写真、方眼、等幅",
  "blue screen": "ブルースクリーン",
  "a very polite crash": "とても礼儀正しいクラッシュ",
  "deep sea": "深海",
  "abyss and slow bubbles": "深淵とゆっくりの泡",
  "quiet paper": "しずかな紙",
  "light, calm, no effects": "明るく静か、エフェクトなし",
  "nature": "自然",
  "sunset": "夕焼け",
  "dusk violet and a burnt orange sun": "夕暮れの紫と焦げたオレンジの太陽",
  "forest": "森",
  "moss, wet bark and leaf green": "苔、濡れた樹皮、葉の緑",
  "coffee": "コーヒー",
  "espresso brown and crema": "エスプレッソブラウンとクレマ",
  "ice": "氷",
  "frozen pale blue and deep water ink": "凍った淡い青と深い水のインク",
  "matcha": "抹茶",
  "soft green tea and a dark leaf": "やわらかな緑茶と濃い葉",
  "vapor": "ベイパー",
  "late night mall, pink on purple with a cyan edge": "深夜のモール、紫の上のピンクとシアンの縁",
  "bsod": "bsod",
  "a blue screen, white text, nothing to hide": "青い画面、白い文字、隠すものなし",
  "blueprint": "ブループリント",
  "cyan ink on drafting blue": "製図ブルーにシアンのインク",
  "dsi": "dsi",
  "glossy white handheld and its blue menu": "つやのある白い携帯機と青いメニュー",
  "waves": "波",
  "honeycomb": "ハニカム",
  "diamonds": "ひし形",
  "cross stitch": "クロスステッチ",
  "embers": "燠火",
  "bubbles": "あわ",
  "code rain": "コードの雨",
  "saved, type to replace": "保存済み、入力すると置き換え",
  "not set": "未設定",
  "token copied": "トークンをコピーしました",
  "make a new extension token? the old one stops working until you paste the new one in": "新しい拡張機能トークンを作りますか？新しいものを貼り付けるまで古いものは使えなくなります",
  "new token made": "新しいトークンを作りました",
  "log out of chix on every device?": "すべての端末でchixからログアウトしますか？",
  "auto": "自動",
  "€ euro": "€ ユーロ",
  "$ dollar": "$ ドル",
  "£ pound": "£ ポンド",
  "¥ yen": "¥ 円",
  "C$ canadian": "C$ カナダドル",
  "A$ australian": "A$ 豪ドル",
  "CHF swiss franc": "CHF スイスフラン",
  "talking to plane": "planeと通信中",
  "connected to {workspace}, now pick your boards": "{workspace}に接続しました。ボードを選んでね",
  "open plane": "planeを開く",
  "in safari, create an api token in profile settings, paste it below, then save": "safariで、プロフィール設定でapiトークンを作り、下に貼り付けて保存してね",
  "couldn't do that": "できませんでした",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "googleがマップのキーを拒否しました。このサイトで許可されているか、maps javascript apiが有効か確認してね",
  "the map needs a key to draw, searches and routes still work below": "地図の表示にはキーが必要です。検索とルートは下で使えます",
  "the map couldn't load. searches and routes still work below": "地図を読み込めませんでした。検索とルートは下で使えます",
  "you": "あなた",
  "new pin": "新しいピン",
  "open now": "営業中",
  "closed now": "営業時間外",
  "new": "新規",
  "{rating} from 1 review": "{rating}（レビュー1件）",
  "{rating} from {count} reviews": "{rating}（レビュー{count}件）",
  "no reviews yet": "レビューはまだありません",
  "no parking info": "駐車場情報なし",
  "no parking listed": "駐車場の記載なし",
  "pin": "ピン",
  "{place} is stop {letter}": "{place}は経由地{letter}です",
  "save": "保存",
  "looking…": "探しています…",
  "nothing found there. try further out or other words": "見つかりませんでした。範囲を広げるか別の言葉で試してね",
  "pick something to look for, or search above": "探すものを選ぶか、上で検索してね",
  "{what} within {distance} of {place}": "{place}から{distance}以内の{what}",
  "around {place}": "{place}周辺",
  "ten stops is the most": "経由地は10か所までです",
  "taken out of saved": "保存から外しました",
  "remove {name}?": "{name}を削除しますか？",
  "nothing saved yet": "保存したものはまだありません",
  "tap the map": "地図をタップ",
  "drop a pin": "ピンを置く",
  "edit {name}": "{name}を編集",
  "save pin": "ピンを保存",
  "my pin": "マイピン",
  "pinned": "ピンを置きました",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "場所、評価、駐車場、ルートはgoogle mapsから取得します。google cloudアカウントのキーが必要です。googleは毎月無料枠をくれます",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractalがまだgoogle mapsのキーを追加していないので、地図で検索できません",
  "within {distance}": "{distance}以内",
  "this area": "このあたり",
  "couldn't find where you are, staying around {place}": "現在地が見つからないので、{place}周辺のままにします",
  "cyan": "シアン",
  "violet": "バイオレット",
  "amber": "アンバー",
  "green": "グリーン",
  "red": "レッド",
  "tap the map where the pin goes": "ピンを置く場所を地図でタップしてね",
  "couldn't find where you are": "現在地が見つかりませんでした",
  "take this pin off the map?": "このピンを地図から外しますか？",
  "where i am": "現在地",
  "home ({place})": "自宅（{place}）",
  "name this route": "このルートに名前をつけて",
  "{from} to {to}": "{from}から{to}",
  "route saved": "ルートを保存しました",
  "food": "食べ物",
  "cafés": "カフェ",
  "pubs and bars": "パブとバー",
  "takeaway": "テイクアウト",
  "shops": "お店",
  "fuel": "ガソリン",
  "parking": "駐車場",
  "pharmacy": "薬局",
  "parks": "公園",
  "things to see": "見どころ",
  "cinema": "映画館",
  "ev charging": "ev充電",
  "drive": "車",
  "walk": "徒歩",
  "cycle": "自転車",
  "bus/train": "バス/電車",
  "{amount} a month": "月{amount}",
  "by {date}": "{date}まで",
  "monthly, stopped {date}": "毎月、{date}に停止",
  "monthly from {date}": "{date}から毎月",
  "on {date}": "{date}",
  "added by you": "あなたが追加",
  "added by {name}": "{name}が追加",
  "{done} paid of {total} · {left} left": "{total}中{done}支払済 · 残り{left}",
  "paid off · {total}": "完済 · {total}",
  "{done} saved of {total} · {left} to go": "{total}中{done}貯金済 · あと{left}",
  "reached · {done}": "達成 · {done}",
  "in": "収入",
  "bill": "請求",
  "cost": "出費",
  "debt": "借金",
  "goal": "目標",
  "remove {name}? its history goes too": "{name}を削除しますか？履歴も消えます",
  "restart": "再起動",
  "stop": "停止",
  "paid": "支払済",
  "payment logged": "支払いを記録しました",
  "saved toward it": "貯金に追加しました",
  "took back the last one": "最後のひとつを取り消しました",
  "{amount} left": "残り{amount}",
  "{amount} saved": "{amount}貯金",
  "out": "支出",
  "no monthly bills yet": "毎月の請求はまだありません",
  "owe": "借り",
  "{percent}% of {total}": "{total}の{percent}%",
  "{amount} this month": "今月{amount}",
  "owed in total": "借入総額",
  "target": "目標額",
  "a month (optional)": "月額（任意）",
  "how much comes in": "入ってくる金額",
  "how much": "金額",
  "by": "期限",
  "since": "開始日",
  "from": "から",
  "on": "日付",
  "where it comes from": "どこから入るか",
  "rent, phone, adobe…": "家賃、電話、adobe…",
  "what you bought": "買ったもの",
  "who or what you owe": "誰に何を借りているか",
  "what you're saving for": "何のために貯めているか",
  "add": "追加",
  "add to the budget": "予算に追加",
  "added": "追加しました",
  "couldn't save that": "保存できませんでした",
  "due: {title}": "期限: {title}",
  "unexpected \"{char}\"": "予期しない「{char}」",
  "missing )": ")がありません",
  "expected a number": "数字が必要です",
  "that goes to infinity": "無限大になります",
  "not set, add it in setup": "未設定、設定で追加してね",
  "{spent} of {budget} for tagging": "タグ付け用{budget}中{spent}",
  "no cap on tagging": "タグ付けの上限なし",
  "{count} refs waiting since {time}": "{time}から{count}件の資料が待機中",
  "none running": "実行中なし",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls}回 · 入力{input} · キャッシュ{cached} · 出力{output}",
  "nothing yet for {month}": "{month}はまだ何もありません",
  "{calls} calls": "{calls}回",
  "split starts with the next answer": "次の返答から分担が始まります",
  "could not read claude usage": "claudeの使用量を読み込めませんでした",
  "all": "すべて",
  "start {name}?": "{name}を起動しますか？",
  "starting {name}...": "{name}を起動中...",
  "{name} start sent": "{name}の起動を送信しました",
  "stop {name}?": "{name}を停止しますか？",
  "stopping {name}...": "{name}を停止中...",
  "{name} stop sent": "{name}の停止を送信しました",
  "restart {name}?": "{name}を再起動しますか？",
  "restarting {name}...": "{name}を再起動中...",
  "{name} restart sent": "{name}の再起動を送信しました",
  "running": "実行中",
  "stopped": "停止中",
  "crash looping": "クラッシュを繰り返し中",
  "starting": "起動中",
  "up {time}": "稼働 {time}",
  "{count} restarts": "再起動{count}回",
  "{name} logs": "{name}のログ",
  "loading...": "読み込み中...",
  "{used} of {total}": "{total}中{used}",
  "could not reach the server: {error}": "サーバーに接続できませんでした: {error}",
  "validating caddy...": "caddyを検証中...",
  "caddy reloaded": "caddyを再読み込みしました",
  "{label}, one per line": "{label}（1行に1つ）",
  "change picture": "画像を変更",
  "all {n}": "すべて {n}",
  "unsorted": "未分類",
  "under a cent": "1セント未満",
  "chi looking {done}/{total}": "chiが確認中 {done}/{total}",
  "chi look {done}/{total}": "chiの目 {done}/{total}",
  "chi looked": "chi確認済み",
  "chi has looked at every character picture": "chiはすべてのキャラ画像を確認済みです",
  "{n} more wait for another press.": "残り{n}枚はもう一度押すと進みます。",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chiは{total}枚中{done}枚のキャラ画像を確認済みです。次の{count}枚を約{price}で確認する？半額バッチで処理するので時間がかかることがあります。",
  "chi is looking at {count} pictures": "chiが{count}枚の画像を確認中",
  "could not start chi": "chiを開始できませんでした",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "chiがまだ見ていない{name}の画像1枚を確認する？約{price}",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "chiがまだ見ていない{name}の画像{count}枚を確認する？約{price}",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chiは{name}の画像{total}枚をすべて確認済みです。最初から確認し直す？約{price}",
  "chi is looking at {name}": "chiが{name}を確認中",
  "picture {n}": "画像{n}",
  "adding 1 picture…": "画像を1枚追加中…",
  "adding {n} pictures…": "画像を{n}枚追加中…",
  "picture added": "画像を追加しました",
  "{n} pictures added": "画像を{n}枚追加しました",
  "could not add the picture": "画像を追加できませんでした",
  "take this picture off the character?": "この画像をキャラから外す？",
  "picture removed": "画像を削除しました",
  "could not remove the picture": "画像を外せませんでした",
  "sheet picture changed": "シートの画像を変更しました",
  "could not change the picture": "画像を変更できませんでした",
  "fetching characters from {source}…": "{source}からキャラを取得中…",
  "{n} found": "{n}件見つかりました",
  "{n} added": "{n}件追加",
  "{n} updated": "{n}件更新",
  "{n} duplicates merged": "重複{n}件を統合",
  "{n} failed": "{n}件失敗",
  "{source} import failed": "{source}の取り込みに失敗しました",
  "aka {names}": "別名 {names}",
  "{n} pictures": "画像{n}枚",
  "merge into {name}": "{name}に統合",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "{other}を{name}に統合する？{other}のシートは消え、画像は{name}に移ります。",
  "{other} merged into {name}": "{other}を{name}に統合しました",
  "the sheet": "シート",
  "could not merge": "統合できませんでした",
  "character saved": "キャラクターを保存しました",
  "could not save": "保存できませんでした",
  "delete {name}?": "{name}を削除しますか？",
  "1 block today": "今日は1ブロック",
  "{n} blocks today": "今日は{n}ブロック",
  "resume": "再開",
  "back to drawing": "描くのに戻ろう",
  "break time, stretch your hand": "休憩タイム、手をストレッチしよう",
  "focus block started": "集中ブロック開始",
  "take a break": "休憩しよう",
  "type minutes, like 40 or 1h30": "分数を入力、例：40や1h30",
  "drop this picture": "この画像を外す",
  "toss {hex}?": "{hex}を捨てる？",
  "copied {hex}": "{hex}をコピーしました",
  "prompt copied": "プロンプトをコピーしました",
  "commissions": "依頼",
  "no commissions": "依頼なし",
  "comms money": "依頼の収入",
  "{n} paid": "{n}件支払済",
  "{n} others": "ほか{n}件",
  "nothing paid yet": "まだ支払いなし",
  "that task is done or gone": "そのタスクは完了済みか削除されています",
  "unlink {title}": "{title}のリンクを解除",
  "no task matches": "一致するタスクなし",
  "no open tasks. add one in tasks first": "未完了のタスクはありません。先にタスクで追加してね",
  "for {client}": "{client}向け",
  "paid {day}": "{day}支払",
  "due {date}": "期限 {date}",
  "commission saved": "依頼を保存しました",
  "commission added": "依頼を追加しました",
  "break": "休憩",
  "unknown": "不明",
  "fapped {n} times": "{n}回fap",
  "no doodles match": "一致する落書きなし",
  "could not load the doodles": "落書きを読み込めませんでした",
  "no picture on the clipboard": "クリップボードに画像がありません",
  "pick a picture": "画像を選んでね",
  "you can look at the doodles, not add them": "落書きは見るだけで、追加はできません",
  "adding the doodle": "落書きを追加中",
  "adding {n} of {total}": "{total}件中{n}件目を追加中",
  "{n} doodles added": "落書きを{n}件追加しました",
  "could not add that": "追加できませんでした",
  "press ctrl+v or ⌘v to paste": "ctrl+vか⌘vで貼り付けてね",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "クリップボードを読めませんでした。ctrl+vか⌘vを試してね",
  "gone": "削除済み",
  "remove {name}": "{name}を削除",
  "new doodle": "新しい落書き",
  "doodle saved": "落書きを保存しました",
  "delete this doodle?": "この落書きを削除する？",
  "could not delete": "削除できませんでした",
  "by {name}": "作者：{name}",
  "one a day per doodle, come back tomorrow": "1つの落書きにつき1日1回、また明日ね",
  "today ✓ {n}": "今日 ✓ {n}",
  "fapped {n}×": "fap {n}回",
  "you {n}": "あなた {n}",
  "could not count that": "カウントできませんでした",
  "random full body poses from the pocketbase library": "pocketbaseライブラリからランダムな全身ポーズ",
  "{n} refs in the pool": "対象の資料 {n}件",
  "no refs match yet": "一致する資料はまだありません",
  "could not fetch poses": "ポーズを取得できませんでした",
  "play": "再生",
  "no poses to draw from": "描けるポーズがありません",
  "{n} poses done, nice": "{n}ポーズ完了、いいね",
  "{n} answered today": "今日{n}枚回答",
  "{n} day streak": "{n}日連続",
  "nothing due right now, {n} learning cards come back in {minutes}m": "今は復習なし。学習中のカード{n}枚が{minutes}分後に戻ります",
  "today's cards are done, see you tomorrow": "今日のカードは完了、また明日",
  "no cards to study, switch a deck on below": "学習するカードがありません。下でデッキをオンにしてね",
  "{seen} of {total} seen · {solid} solid": "{total}枚中{seen}枚学習済み · 定着{solid}枚",
  "study {deck}": "{deck}を学習",
  "could not load the deck": "デッキを読み込めませんでした",
  "could not save that answer": "その回答を保存できませんでした",
  "could not save the deck setup": "デッキ設定を保存できませんでした",
  "basics": "基本",
  "favourites": "お気に入り",
  "likes and goals": "好きなことと目標",
  "looks": "見た目",
  "identity": "人物像",
  "sexuality": "セクシュアリティ",
  "story": "ストーリー",
  "for chi": "chi向け",
  "orientation": "指向",
  "trivia": "豆知識",
  "created by": "作者",
  "world": "世界",
  "location": "場所",
  "race": "種族",
  "occupation": "職業",
  "gender": "性別",
  "height": "身長",
  "favourite food": "好きな食べ物",
  "smell": "におい",
  "pet peeve": "苦手なこと",
  "likes": "好きなもの",
  "dislikes": "嫌いなもの",
  "look in short": "見た目の要約",
  "body": "体",
  "clothes": "服装",
  "visual features": "見た目の特徴",
  "speaking": "話し方",
  "personality": "性格",
  "relationships": "人間関係",
  "items": "持ち物",
  "skills": "スキル",
  "preferences": "好み",
  "fetishes": "フェチ",
  "sexual trivia": "性的な豆知識",
  "rpg sheet": "RPGシート",
  "fractal's notes for chi": "fractalからchiへのメモ",
  "sees your {kinds}": "{kinds}を見られます",
  "sees nothing of yours": "あなたのものは何も見られません",
  "{line}, adds to your {kinds}": "{line}、{kinds}に追加できます",
  "{name} can add to your {kind}": "{name}は{kind}に追加できます",
  "{name} can only read your {kind}": "{name}は{kind}を見るだけです",
  "{name} can see your {kind}": "{name}は{kind}を見られます",
  "{kind} hidden from {name}": "{kind}を{name}から非表示にしました",
  "{name} can see everything you can share": "{name}は共有できるものをすべて見られます",
  "{name} sees nothing of yours now": "{name}はもうあなたのものを何も見られません",
  "share {kind} with {name}": "{kind}を{name}と共有",
  "you don't have notes, pings or anything else to share yet": "共有できるメモや通知などはまだありません",
  "share all": "すべて共有",
  "share none": "共有しない",
  "nobody else is in chix yet": "chixにはまだ他に誰もいません",
  "shares their {kinds}": "{kinds}を共有しています",
  "Calendar events": "カレンダーの予定",
  "Places and routes": "場所とルート",
  "your sticky notes": "あなたの付箋メモ",
  "reminders, alarms and timers": "リマインダー、アラーム、タイマー",
  "your own events on the month": "月のあなたの予定",
  "plane and chix bot": "planeとchixボット",
  "clients, prices, status, linked tasks and money stats": "クライアント、価格、状況、関連タスク、お金の統計",
  "bills, costs, debts and goals": "請求、出費、借金、目標",
  "what you keep up and your streaks": "続けていることと連続記録",
  "spots and routes you saved on the map": "マップに保存した場所とルート",
  "Can add to it": "追加できる",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "請求、出費、収入、支払いを本人の名前で追加。変更できるのは自分が追加したものだけです",
  "off": "オフ",
  "{on} of {total} on · chi {spent} of {cap}": "{total}件中{on}件オン · chi {spent} / {cap}",
  "{on} of {total} on · chi {spent}": "{total}件中{on}件オン · chi {spent}",
  "{feature} off for {name}": "{name}の{feature}をオフにしました",
  "{name} can view {feature}": "{name}は{feature}を見られます",
  "{name} can edit {feature}": "{name}は{feature}を編集できます",
  "{feature} for {name}": "{name}の{feature}",
  "monthly chi cap, usd": "chiの月間上限（USD）",
  "{name}'s chi stops at {amount} a month": "{name}のchiは月{amount}で止まります",
  "no cap for {name}": "{name}は上限なし",
  "{spent} over {count} answers this month. 0 means no cap": "今月は{count}件の返答で{spent}。0は上限なし",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "{name}を削除しますか？ログアウトされます。また追加すれば、メモやチャットはサーバーに残っています",
  "{name} removed": "{name}を削除しました",
  "just you for now": "今はあなただけです",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name}がログインできるようになりました。最初はchi、メモ、通知、ルーティンが使えます",
  "Calendar and pings": "カレンダーと通知",
  "Chi speaker": "Chiスピーカー",
  "Discord messages": "discordメッセージ",
  "Keys and server setup": "キーとサーバー設定",
  "their own chat and memory, on your claude account": "本人のチャットと記憶、あなたのclaudeアカウントで",
  "the shared ref library": "共有の資料ライブラリ",
  "the shared oc sheets": "共有のOCシート",
  "their own": "本人のもの",
  "plane and chix bot, their own": "planeとchixボット、本人のもの",
  "timer, palette, prompts, comms and their money stats": "タイマー、パレット、お題、依頼、本人のお金の統計",
  "their own bills, costs, debts and goals": "本人の請求、出費、借金、目標",
  "places nearby, routes and their saved spots, on your google maps key": "近くの場所、ルート、保存した場所、あなたのgoogle mapsキーで",
  "gesture drawing and japanese": "ジェスチャードローイングと日本語",
  "the shared doodle wall": "共有の落書きウォール",
  "their own scan library": "本人のスキャンライブラリ",
  "their pings ring at home, chi answers their voice": "本人の通知が家で鳴り、chiが声に答えます",
  "chi can dm your contacts for them": "chiが代わりにあなたの連絡先にDMを送れます",
  "vps panel and bot controls": "VPSパネルとボット操作",
  "every log line": "すべてのログ行",
  "spend and billing": "支出と請求",
  "api keys, ssh": "APIキー、ssh",
  "this dashboard": "このダッシュボード",
  "tap to upload": "タップしてアップロード",
  "{count} kept": "{count}件保存",
  "uploading {n} of {total}": "{total}件中{n}件目をアップロード中",
  "scan kept": "スキャンを保存しました",
  "{count} scans kept": "{count}件のスキャンを保存しました",
  "upload failed": "アップロードに失敗しました",
  "the brother is scanning": "brotherがスキャン中",
  "scan failed": "スキャンに失敗しました",
  "saving {n} of {total}": "{total}件中{n}件目を保存中",
  "added to scans": "スキャンに追加しました",
  "could not save that": "保存できませんでした",
  "pdf scan, use download to open it": "PDFスキャンです。ダウンロードして開いてください",
  "delete this scan?": "このスキャンを削除しますか？",
  "days apart": "日おき",
  "times a week, any days": "週の回数、曜日は自由",
  "day of the month": "毎月の日付",
  "added by another part of chix, ticked off there too": "chixの別の場所で追加されました。そちらでもチェックされます",
  "delete {title} and its history?": "{title}と履歴を削除しますか？",
  "no routines": "ルーティンなし",
  "ChiX routine": "ChiXルーティン",
  "time for {title}": "{title}の時間です",
  "weekdays": "平日",
  "every {n} days": "{n}日ごと",
  "{n}x a week": "週{n}回",
  "monthly on day {day}": "毎月{day}日",
  "{done}/{times} this week": "今週{done}/{times}",
  "ping {time}": "{time}に通知",
  "{n}w streak": "{n}週連続",
  "{n} streak": "{n}日連続",
  "{title} done": "{title}完了",
  "sticky {date}": "付箋 {date}",
  "saved {time}": "{time}に保存",
  "nothing coming up": "予定はありません",
  "edit chix task": "chixタスクを編集",
  "new chix task": "新しいchixタスク",
  "saving...": "保存中...",
  "mark \"{title}\" as done?": "「{title}」を完了にしますか？",
  "urgent": "緊急",
  "high": "高",
  "medium": "中",
  "low": "低",
  "{count} shown, updated {time}": "{count}件表示、{time}に更新",
  "nothing pending": "保留中のものはありません",
  "night": "ナイト",
  "fog": "フォグ",
  "ember": "エンバー",
  "abyss": "アビス",
  "petal": "ペタル",
  "peach": "ピーチ",
  "mint": "ミント",
  "lilac": "ライラック",
  "starlight": "スターライト",
  "venom": "ヴェノム",
  "pocket": "ポケット",
  "{title} reached, tap done to cross it off": "{title}に到達、完了をタップして消そう",
  "delete {title}? it won't come back": "{title}を削除する？元に戻せません",
  "done · {n}": "完了 · {n}",
  "no goals": "目標なし",
  "this one's done, saving keeps it crossed out": "これは完了済み。保存しても消えたままです",
  "no goals on the go": "進行中の目標なし",
  "add a couple of options": "選択肢をいくつか追加",
  "last one standing: {label}": "最後に残ったのは: {label}",
  "everything's been knocked out": "すべて脱落しました",
  "spinning": "回転中",
  "the wheel says": "ルーレットの結果",
  "new wheel": "新しいホイール",
  "knocked out": "脱落",
  "{n} on the wheel, {out} knocked out": "ルーレット上に{n}個、{out}個脱落",
  "{n} on the wheel": "ルーレット上に{n}個",
  "just now": "たった今",
  "{n}m ago": "{n}分前",
  "{n}h ago": "{n}時間前",
  "ready": "準備OK",
  "flick the wheel or press spin": "ホイールをはじくか、回すを押してね",
  "add a couple of options to spin": "選択肢をいくつか追加して回そう",
  "a wheel holds {max} options": "ルーレットには{max}個まで入ります",
  "only {room} fit, a wheel holds {max}": "入るのは{room}個だけ、上限は{max}個です",
  "my characters": "自分のキャラクター",
  "there aren't enough characters yet": "キャラクターがまだ足りません",
  "which oc": "どのOC",
  "{name} copy": "{name}のコピー",
  "delete the wheel \"{name}\"?": "ルーレット「{name}」を削除する？",
  "yes or no": "はい・いいえ",
  "what to draw": "何を描く",
  "dinner": "夕食",
  "dice": "サイコロ",
  "who does it": "誰がやる",
  "yes": "はい",
  "no": "いいえ",
  "gesture warm up": "ジェスチャーのウォームアップ",
  "portrait": "ポートレート",
  "an oc": "OC一枚",
  "hands and feet": "手と足",
  "background": "背景",
  "comic page": "漫画1ページ",
  "fanart": "ファンアート",
  "redraw an old piece": "昔の絵を描き直す",
  "pizza": "ピザ",
  "sushi": "寿司",
  "curry": "カレー",
  "burgers": "ハンバーガー",
  "noodles": "麺",
  "cook something": "何か作る",
  "yellow": "イエロー",
  "orange": "オレンジ",
  "lime": "ライム",
  "teal": "ティール",
  "blue": "ブルー",
  "purple": "パープル",
  "pink": "ピンク",
  "white": "ホワイト",
  "black": "ブラック",
  "sky": "スカイ",
  "slate": "スレート",
  "edit message": "メッセージを編集",
  "delete your message? it goes for everyone": "自分のメッセージを削除する？全員から消えます",
  "delete {name}'s message? it goes for everyone": "{name}のメッセージを削除する？全員から消えます",
  "couldn't delete that": "削除できませんでした",
  "couldn't post that": "投稿できませんでした",
  "1 message": "1件のメッセージ",
  "{n} messages": "{n}件のメッセージ",
  "someone": "だれか",
  "edited": "編集済み",
  "now": "今",
  "{n}m": "{n}分",
  "{n}h": "{n}時間",
  "+{n} more": "ほか{n}件",
  "couldn't switch": "切り替えできませんでした",
  "switch": "切り替え",
  "profile": "プロフィール",
  "that isn't a picture": "画像ではありません",
  "picture saved": "画像を保存しました",
  "upload picture": "画像をアップロード",
  "use {name}'s discord picture": "{name}のdiscord画像を使う",
  "remove picture": "画像を削除",
  "owned by": "所有者",
  "remove {name} as an owner": "{name}を所有者から外す",
  "owner removed": "所有者を外しました",
  "another discord user id": "別のdiscordユーザーID",
  "discord user id": "discordユーザーID",
  "add owner": "所有者を追加",
  "they can sign in as {name} now": "{name}としてログインできます",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "alterを所有するdiscordアカウントはログインして切り替えられます。alter自身のアカウントをここに入れてね",
  "a line about them": "ひとこと紹介",
  "pronouns": "代名詞",
  "about": "自己紹介",
  "be {name}": "{name}になる",
  "{name} is part of {system}": "{name}は{system}のメンバー",
  "back to my profile": "自分のプロフィールに戻る",
  "remove {name}? their notes and chats stay on the server if you add them back": "{name}を削除する？再追加すればメモとチャットはサーバーに残っています",
  "no alters yet. add the first one above": "alterはまだいません。上から最初のひとりを追加しよう",
  "{name} added": "{name}を追加しました",
  "size: {size}, change": "サイズ: {size}、変更",
  "small": "小",
  "half": "半分",
  "wide": "ワイド",
  "hide": "非表示",
  "move earlier": "前に移動",
  "move later": "後ろに移動",
  "hold to drag": "長押しでドラッグ",
  "arrange home": "ホームを並べ替え",
  "ask chi": "chiに聞く",
  "inbox": "受信箱",
  "gauges": "ゲージ",
  "message board": "メッセージボード",
  "spin": "回す",
  "cat": "猫",
  "Cat mode": "猫モード",
  "press ALT P TO EXIT CAT MODE": "ALT P で猫モードを終了",
  "{n} lines": "{n}本",
  "live": "ライブ",
  "no shared boards yet. make one and everyone can draw on it together": "共有ボードはまだありません。作ればみんなで一緒に描けます",
  "no shared boards yet. Fractal can make one": "共有ボードはまだありません。Fractalが作れます",
  "{shared} shared · {mine} yours": "共有{shared} · あなたの{mine}",
  "could not load the boards": "ボードを読み込めませんでした",
  "could not make a board": "ボードを作れませんでした",
  "that board was deleted": "そのボードは削除されました",
  "shared board": "共有ボード",
  "board": "ボード",
  "offline, will send when back": "オフライン、復帰したら送信します",
  "that's someone else's, only they can change it": "それはほかの人のものなので、その人だけが変更できます",
  "lost the board": "ボードが見つかりません",
  "that layer is hidden, show it to draw": "そのレイヤーは非表示です。描くには表示してください",
  "that layer is hidden, show it to write": "そのレイヤーは非表示です。書くには表示してください",
  "that layer is locked": "そのレイヤーはロックされています",
  "that layer is {who}'s, ask them to let you draw on it": "そのレイヤーは{who}のものです。描かせてもらえるよう頼んでみてください",
  "that layer has other people's lines, use the stroke eraser": "そのレイヤーにはほかの人の線があります。線消しゴムを使ってください",
  "pencil found, fingers now move the board": "ペンを検出しました。指ではボードを動かします",
  "{n} frames": "{n}フレーム",
  "open": "開く",
  "empty": "空",
  "this layer is yours": "このレイヤーはあなたのものです",
  "{who}'s layer": "{who}のレイヤー",
  ", open to everyone": "、全員に開放",
  ", only they draw here": "、描けるのはその人だけ",
  "frames": "フレーム",
  "animate": "アニメーション",
  "layer {n}": "レイヤー{n}",
  "delete {name}? you can undo it": "{name}を削除しますか?元に戻せます",
  "{name} cleared, undo brings it back": "{name}を消去しました。元に戻せます",
  "{n} frames is the most a layer holds": "1つのレイヤーは最大{n}フレームです",
  "delete frame {n}? you can undo it": "フレーム{n}を削除しますか?元に戻せます",
  "frame {n}": "フレーム{n}",
  "frames per second": "1秒あたりのフレーム数",
  "onion skin {state}": "オニオンスキン {state}",
  "shared · look only": "共有 · 閲覧のみ",
  "shared · live": "共有 · ライブ",
  "private": "非公開",
  "paper {color}": "紙 {color}",
  "could not make the picture": "画像を作れませんでした",
  "draw something first": "まず何か描いてね",
  "posted to the doodle wall": "らくがきウォールに投稿しました",
  "could not post it": "投稿できませんでした",
  "delete {name}? this can't be undone": "{name}を削除しますか?元に戻せません",
  "delete {name}? this can't be undone, and it goes for everyone": "{name}を削除しますか?元に戻せず、全員から消えます",
  "could not delete it": "削除できませんでした",
  "could not open that board": "そのボードを開けませんでした",
  "brush": "ブラシ",
  "erase": "消す",
  "select": "選択",
  "shape": "図形",
  "text": "テキスト",
  "move": "移動",
  "line": "線",
  "arrow": "矢印",
  "box": "四角",
  "ellipse": "楕円",
  "sans": "ゴシック",
  "serif": "明朝",
  "mono": "等幅",
  "display": "装飾",
  "rub out": "こすって消す",
  "whole strokes": "線ごと",
  "duplicate": "複製",
  "delete": "削除",
  "done": "完了",
  "drag to pick, tap one stroke": "ドラッグで選択、線をタップ",
  "show": "表示",
  "lock": "ロック",
  "unlock": "ロック解除",
  "move up": "上へ",
  "move down": "下へ",
  "stop playing": "再生を止める",
  "play this layer": "このレイヤーを再生",
  "previous frame": "前のフレーム",
  "next frame": "次のフレーム",
  "new empty frame": "新しい空のフレーム",
  "copy this frame": "このフレームをコピー",
  "delete this frame": "このフレームを削除",
  "move this frame earlier": "このフレームを前へ",
  "move this frame later": "このフレームを後ろへ",
  "plain": "無地",
  "lines": "罫線",
  "pen": "ペン",
  "pencil": "鉛筆",
  "ink": "インク",
  "marker": "マーカー",
  "glow": "グロー",
  "eraser": "消しゴム",
  "water": "水彩",
  "air": "エア",
  "spray": "スプレー",
  "coal": "木炭",
  "chalk": "チョーク",
  "crayon": "クレヨン",
  "rainbow": "レインボー",
  "glitter": "グリッター",
  "neon": "ネオン",
  "boil": "ボイル",
  "wave": "波",
  "flame": "炎",
  "march": "行進",
  "glitch": "グリッチ",
  "pulse": "パルス",
  "draw": "描く",
  "paint": "塗る",
  "texture": "テクスチャ",
  "steady": "手ぶれ補正",
  "pressure": "筆圧",
  "soft": "やわらか",
  "spread": "広がり",
  "reset this brush": "このブラシをリセット",
  "normal": "ふつう",
  "multiply": "乗算",
  "screen": "スクリーン",
  "overlay": "オーバーレイ",
  "soft light": "ソフトライト",
  "hard light": "ハードライト",
  "darken": "比較(暗)",
  "lighten": "比較(明)",
  "color dodge": "覆い焼き",
  "color burn": "焼き込み",
  "difference": "差の絶対値",
  "exclusion": "除外",
  "Goals": "目標",
  "me": "自分",
  "Profile": "プロフィール",
  "Message board": "メッセージボード",
  "Roulette": "ルーレット",
  "Whiteboards": "ホワイトボード",
  "nothing on the board yet": "ボードにはまだ何もありません",
  "add to a": "追加先：",
  "default": "デフォルト",
  "out of": "／",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "目標はまだありません。仕上げたい章、目指すページ数、取り組んでいることなど、何でも追加しよう",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "かなは標準の五十音表です。漢字はJLPT N5〜N1の2,211字で、意味と読みはkanjidic2（edrdg、cc by-sa 4.0）、レベルはJonathan WallerのJLPTリスト（cc by）から",
  "bring all back": "すべて戻す",
  "slices": "スライス",
  "history": "履歴",
  "options": "選択肢",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "リストを貼り付けるとまとめて追加されます。pizza *3 でpizzaが3倍出やすくなり、下の重みでスライスごとに調整できます",
  "no options yet. add a few, or start from a preset in options": "オプションはまだありません。いくつか追加するか、オプションのプリセットから始めよう",
  "shuffle": "シャッフル",
  "even odds": "確率を均等に",
  "theme colours": "テーマカラー",
  "tally": "集計",
  "last spins": "最近の結果",
  "nothing spun on this wheel yet": "このホイールはまだ回していません",
  "after a spin": "回したあと",
  "keep it": "そのまま",
  "knock it out": "除外する",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "除外すると、当たった項目は全部戻すまでホイールから外れます。順番決めやトーナメントに便利",
  "spin length": "回転の長さ",
  "quick": "短め",
  "drama": "ドラマ",
  "clicks and a jingle": "クリック音とジングル",
  "new wheel from": "新しいホイール：",
  "copy this wheel": "このホイールをコピー",
  "delete wheel": "ホイールを削除",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "当選は端末の安全な乱数で、各スライスの重みに比例して選ばれます。2倍の大きさに見えるスライスは、本当に2倍当たりやすいです",
  "wheel": "ホイール",
  "the wheel, flick it to spin": "ホイール。はじくと回ります",
  "add options, one per line": "オプションを1行に1つずつ追加",
  "option": "選択肢",
  "weight": "重み",
  "less likely": "出にくく",
  "more likely": "出やすく",
  "less": "少なく",
  "more": "多く",
  "shared": "共有",
  "new board": "新しいボード",
  "mine · private": "自分 · 非公開",
  "no boards of your own yet. only you ever see these": "自分のボードはまだありません。ここは自分だけに見えます",
  "layers": "レイヤー",
  "opacity": "不透明度",
  "blend": "合成",
  "let others draw on this layer": "このレイヤーに他の人も描けるようにする",
  "brush ·": "ブラシ ·",
  "pick from the board": "ボードから選ぶ",
  "recent": "最近",
  "any colour": "好きな色",
  "paper": "用紙",
  "only the pencil draws, fingers move and zoom the board": "描くのはペンだけ。指ではボードの移動とズームができます",
  "fit": "合わせる",
  "save png": "pngで保存",
  "post to doodles": "落書きに投稿",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "二本指でピンチして移動、二本指タップで元に戻す、三本指で進む。キーボード：スペースでドラッグ、[ と ] でサイズ、⌘zで元に戻す、kでブラシ、xでストローク単位の消去、tでテキスト、vで選択、uで図形、カンマとピリオドでコマ送り、バックスラッシュで再生",
  "delete board": "ボードを削除",
  "Board": "ボード",
  "everyone on chi sees this": "chiのみんなに見えます",
  "nothing on the board yet. post the first line": "ボードにはまだ何もありません。最初の一行を投稿しよう",
  "who's here": "今いる人",
  "who is here": "今いる人",
  "jot to inbox": "受信箱にメモ",
  "say something to everyone": "みんなに一言",
  "message for the board": "ボードへのメッセージ",
  "finish the chapter 2 sprites…": "2章のスプライトを仕上げる…",
  "why, or what done looks like, optional": "理由や、達成したときの姿（任意）",
  "progress": "進捗",
  "counting what": "何を数える？",
  "a board everyone can draw on together": "みんなで一緒に描けるボード",
  "a board only you can see": "自分だけに見えるボード",
  "text on the board": "ボード上のテキスト",
  "back to the boards": "ボード一覧に戻る",
  "undo, or tap with two fingers": "元に戻す、または二本指でタップ",
  "redo": "やり直す",
  "redo, or tap with three fingers": "やり直す、または三本指でタップ",
  "fit the drawing on screen": "描いた絵を画面に合わせる",
  "fit to the drawing": "絵に合わせる",
  "board settings": "ボードの設定",
  "brush size": "ブラシのサイズ",
  "say something to everyone…": "みんなに一言…",
  "new alter name": "新しいアルターの名前",
  "emoji": "絵文字",
  "all {count} presets are taken, unpin one first": "{count}個のプリセットがすべて埋まっています。先にどれかを外してね",
  "could not change the owner": "持ち主を変更できませんでした",
  "description": "説明",
  "groups": "グループ",
  "large": "大",
  "layout": "レイアウト",
  "mine {n}": "自分の {n}",
  "owners": "持ち主",
  "presets": "プリセット",
  "reversed": "逆順",
  "sort by": "並べ替え",
  "tap the star on a key to pin it. pins sit above the dock as presets": "キーの星をタップして固定。固定したものはドックの上にプリセットとして並びます",
  "unknown date": "日付不明",
  "{name} is not yours any more": "{name}はもうあなたのものではありません",
  "{name} is yours now": "{name}はあなたのものになりました",
  "Grid": "グリッド",
  "Masonry": "メイソンリー",
  "Rows": "行",
  "Big grid": "大きなグリッド",
  "Wall": "ウォール",
  "Posts": "投稿",
  "Shuffle": "シャッフル",
  "random order, rolled once while it is open": "ランダム順。開いている間は一度だけシャッフル",
  "Newest": "新しい順",
  "latest saved first": "最近保存したものから",
  "Oldest": "古い順",
  "earliest saved first": "最初に保存したものから",
  "Most tagged": "タグが多い順",
  "refs with the most tags first": "タグが多い資料から",
  "Undescribed first": "説明なしを先に",
  "what has no description yet comes first": "まだ説明のないものを先に表示",
  "By tag": "タグ別",
  "grouped under the most used tag": "いちばんよく使うタグでグループ化",
  "By author": "作者別",
  "grouped A to Z": "A〜Zでグループ化",
  "By month": "月別",
  "grouped by the month you saved them": "保存した月でグループ化",
  "By type": "種類別",
  "stills, gifs and clips apart": "静止画、gif、動画を分けて表示",
  "sign in with discord · fractal and pauline": "discordでログイン · fractalとpauline",
  "continue with discord": "discordで続ける",
  "use": "使う",
  "Ready when you are.": "いつでもどうぞ。",
  "local": "現地",
  "unit": "ユニット",
  "chi · online": "chi · オンライン",
  "clear": "良好",
  "tip of the day": "今日のヒント",
  "another one": "もうひとつ",
  "add to a budget": "予算に追加",
  "every month": "毎月",
  "up next": "次は",
  "all tasks": "すべてのタスク",
  "nothing due, go draw": "期限なし、描こう",
  "routines": "ルーティン",
  "routines done for today": "今日のルーティン完了",
  "notes": "メモ",
  "no notes yet": "メモはまだありません",
  "Tasks": "タスク",
  "chix task": "chixタスク",
  "Notes": "メモ",
  "note": "メモ",
  "scratchpad": "スクラッチパッド",
  "edit": "編集",
  "view": "表示",
  "Refs": "資料",
  "random": "ランダム",
  "newest": "新しい順",
  "oldest": "古い順",
  "by tag": "タグ順",
  "stills": "静止画",
  "moving": "動画",
  "chi's description": "chiの説明",
  "your note": "あなたのメモ",
  "ctrl+enter saves and goes next": "ctrl+enterで保存して次へ",
  "edit tags": "タグを編集",
  "close": "閉じる",
  "dialog": "ダイアログ",
  "info": "情報",
  "post": "投稿",
  "next": "次へ",
  "Chi online. What are we drawing?": "Chi オンライン。何を描く？",
  "what should I work on?": "何に取り組むべき？",
  "pose refs": "ポーズ資料",
  "pick an oc": "OCを選ぶ",
  "comms": "依頼",
  "Routines": "ルーティン",
  "routine": "ルーティン",
  "every day": "毎日",
  "on these days": "この曜日に",
  "every few days": "数日おき",
  "times a week": "週に数回",
  "once a month": "月に一度",
  "mon": "月",
  "tue": "火",
  "wed": "水",
  "thu": "木",
  "fri": "金",
  "sat": "土",
  "sun": "日",
  "ping at": "通知時刻",
  "paused": "一時停止中",
  "cancel": "キャンセル",
  "nothing on today": "今日は予定なし",
  "other days": "ほかの日",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "ルーティンはまだありません。毎日のスケッチや週一の配信など、続けたいことを追加しよう",
  "Pings": "通知",
  "reminder": "リマインダー",
  "alarm": "アラーム",
  "timer": "タイマー",
  "once": "一回",
  "daily": "毎日",
  "weekly": "毎週",
  "set": "設定",
  "no pings yet. set one for a stream, a deadline or a break": "通知はまだありません。配信や締め切り、休憩のために設定しよう",
  "Session": "セッション",
  "focus": "集中",
  "start": "開始",
  "tap the time to type your own, like 40 or 1h30": "時間をタップして入力、例：40や1h30",
  "0 blocks today": "今日は0ブロック",
  "Palette": "パレット",
  "keep": "保存",
  "tap a swatch to copy it, hold to toss it": "色をタップでコピー、長押しで削除",
  "Prompts": "プロンプト",
  "save prompt": "プロンプトを保存",
  "tap a card to copy the whole prompt": "カードをタップでプロンプト全体をコピー",
  "Comms": "依頼",
  "tap a commission to edit it": "依頼をタップして編集",
  "list": "リスト",
  "money": "お金",
  "new commission": "新しい依頼",
  "sketch": "ラフ",
  "wip": "作業中",
  "review": "確認",
  "reference pics": "参考画像",
  "this month": "今月",
  "this year": "今年",
  "to be paid": "未払い",
  "paid by month": "月別の支払い",
  "by client": "クライアント別",
  "by status": "状態別",
  "a commission counts on the day it was marked paid. change that day on its card": "依頼は支払済にした日に計上されます。日付はカードで変更できます",
  "Budget": "予算",
  "left": "残り",
  "in and out": "収支",
  "monthly by category": "カテゴリ別の月額",
  "debts and goals": "借金と目標",
  "one off": "単発",
  "monthly": "毎月",
  "bills": "請求",
  "costs": "出費",
  "debts": "借金",
  "goals": "目標",
  "nothing here yet. add a bill, a debt or a goal above": "まだ何もありません。上で請求、借金、目標を追加しよう",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "共有で誰かにオンにしない限り、見えるのはあなただけ。支払済の依頼は収入として数えます",
  "Gesture": "ジェスチャー",
  "timed poses, draw fast, the next one drops in on its own": "時間制限つきのポーズ。素早く描こう、次は自動で出ます",
  "source": "ソース",
  "full body": "全身",
  "my refs": "自分の資料",
  "each pose": "1ポーズ",
  "poses": "ポーズ",
  "pause": "一時停止",
  "skip": "スキップ",
  "Japanese": "日本語",
  "learning": "学習中",
  "show answer": "答えを見る",
  "again": "もう一度",
  "hard": "難しい",
  "good": "普通",
  "easy": "簡単",
  "space shows the answer, 1 to 4 grades it": "スペースで答えを表示、1〜4で評価",
  "decks": "デッキ",
  "new cards a day": "1日の新規カード",
  "study, new cards come in this order": "学習：新規カードはこの順で出ます",
  "Characters": "キャラクター",
  "chi look": "chiの目",
  "no characters match": "一致するキャラクターなし",
  "new character": "新しいキャラクター",
  "name": "名前",
  "tags, comma separated": "タグ（カンマ区切り）",
  "sheet picture": "シートの画像",
  "character file": "キャラクターファイル",
  "chi saw": "chiが見たもの",
  "use as picture": "画像に使う",
  "add pic": "画像を追加",
  "drop pic": "画像を外す",
  "merge": "統合",
  "merge into": "統合先",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "別名の同じキャラクターを選んでね。その画像とこのシートにない情報がここに移り、以後のインポートはこのシートを更新します。",
  "Calendar": "カレンダー",
  "Maps": "マップ",
  "near me": "近く",
  "maps needs a google key": "マップにはgoogleキーが必要です",
  "in console.cloud.google.com make a project and turn on billing": "console.cloud.google.comでプロジェクトを作り、課金を有効にする",
  "turn on": "有効にする：",
  "and": "と",
  "make an api key under credentials, and limit it to those three apis": "認証情報でapiキーを作り、その3つのapiに制限する",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "設定 › キー › google mapsに貼り付け。またはサーバーにGOOGLE_MAPS_API_KEYとして置く",
  "open setup": "設定を開く",
  "search this area": "このエリアを検索",
  "route here": "ここへのルート",
  "route from": "ここからのルート",
  "remove": "削除",
  "nearby": "周辺",
  "route": "ルート",
  "best rated": "高評価順",
  "most reviews": "レビュー数順",
  "closest": "近い順",
  "parking first": "駐車場優先",
  "add where you start and where you're going. places from nearby can go in with their route button": "出発地と目的地を追加。周辺の場所はルートボタンで追加できます",
  "from here": "ここから",
  "home": "自宅",
  "best order for the middle stops": "途中の経由地を最適な順に",
  "plan route": "ルートを計画",
  "time": "時間",
  "distance": "距離",
  "stops": "経由地",
  "pins": "ピン",
  "tap drop a pin, then tap the map where it goes": "「ピンを置く」をタップして、地図の置きたい場所をタップ",
  "pin where i am": "現在地にピン",
  "places": "場所",
  "star a place from nearby to keep it here": "周辺の場所にスターをつけるとここに残ります",
  "routes": "ルート",
  "plan a route and save it to keep it here": "ルートを計画して保存するとここに残ります",
  "only you see these unless you switch places and routes on for someone in sharing": "共有で場所とルートをオンにしない限り、見えるのはあなただけ",
  "tape": "履歴",
  "Scans": "スキャン",
  "photo": "写真",
  "scan": "スキャン",
  "on this pc": "このPC",
  "upload all": "すべてアップロード",
  "scans the brother left in the inbox folder that the web cannot see yet": "brotherが受信フォルダに置いた、まだwebから見えないスキャン",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "スキャンはまだありません。PCでスキャンするか、スケッチを撮影してね",
  "Doodles": "落書き",
  "paste": "貼り付け",
  "no doodles yet. paste one, or add pictures from your phone": "落書きはまだありません。貼り付けるか、スマホから画像を追加してね",
  "doodle": "落書き",
  "title": "タイトル",
  "drawn by": "作者",
  "day": "日付",
  "characters in it": "登場キャラ",
  "undo mine": "自分のを取り消す",
  "newer": "新しい",
  "older": "古い",
  "Server": "サーバー",
  "reload caddy": "caddyを再読み込み",
  "memory": "メモリ",
  "load": "負荷",
  "bots up": "稼働中のbot",
  "bots": "bot",
  "Logs": "ログ",
  "nothing happened yet, it shows up here live": "まだ何もありません。ここにリアルタイムで表示されます",
  "billing": "請求",
  "month": "月",
  "chat": "チャット",
  "tags": "タグ",
  "key": "キー",
  "tagging": "タグ付け",
  "budget": "予算",
  "batch": "バッチ",
  "by model": "モデル別",
  "by person": "人別",
  "estimates from the token counts claude sends back. billing has the real bill": "claudeが返すトークン数からの見積もり。実際の請求は請求ページで",
  "People": "メンバー",
  "let in": "招待",
  "their chi": "その人のchi",
  "yours": "あなたの",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "みんなあなたのclaudeキーでchiと話します。キーは見えず、チャットと記憶はそれぞれのもの。各自の利用分はここで数えます",
  "let someone in": "誰かを招待",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "discordでログインします。追加前に試すと、あなたに送るためのIDが表示されます",
  "only you": "あなただけ",
  "Sharing": "共有",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "各メンバーが見られるものを選んでね。読むだけで変更はできません。その人のメモや通知の横に表示され、その人のchiも読めます",
  "shared with you": "あなたと共有",
  "nobody shares anything with you yet": "まだ誰も何も共有していません",
  "Setup": "設定",
  "assistant": "アシスタント",
  "anthropic api key": "anthropic apiキー",
  "chat model": "チャットモデル",
  "ref tagging model": "資料タグ付けモデル",
  "monthly tagging budget, usd": "月間タグ付け予算（usd）",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "月の見積もりが予算を超えるとタグ付けは止まります。0は上限なし。claude-haiku-4-5の方が安い",
  "currency": "通貨",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "あなただけの設定。依頼・お金の統計・予算の記号です。autoは依頼の入力から読み取ります。選ぶとすぐ保存されます",
  "log into the plane tab, then connect": "planeタブでログインしてから接続",
  "open plane, make an api token in profile settings, paste it here": "planeを開き、プロフィール設定でapiトークンを作ってここに貼り付け",
  "connect plane": "planeに接続",
  "workspace slug": "ワークスペースのスラッグ",
  "api key": "apiキー",
  "load boards": "ボードを読み込む",
  "your discord user id": "あなたのdiscordユーザーID",
  "browser key, optional": "ブラウザキー（任意）",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "apiキーはサーバーから場所検索とルート計画をします。地図はブラウザキーがあればそれで、なければapiキーで読み込みます。サーバーのGOOGLE_MAPS_API_KEYが優先されます",
  "server": "サーバー",
  "bots folder": "botフォルダ",
  "sudo password": "sudoパスワード",
  "ssh host": "sshホスト",
  "ssh user": "sshユーザー",
  "ssh key file": "ssh鍵ファイル",
  "browser extension": "ブラウザ拡張機能",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "拡張機能のオプションにクラウドトークンとして貼り付けてね。あなた専用なので、保存はあなた名義になります",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome：古いフォルダに上書き解凍して、chrome://extensionsで再読み込み。firefox：ファイルをfirefoxで開いて許可すると、以後は自動更新されます",
  "your extension token": "あなたの拡張機能トークン",
  "copy": "コピー",
  "new token": "新しいトークン",
  "links": "リンク",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "1行に1つ、名前 | url の形式で。デスクアプリ内、またはwebでは新しいタブで開きます",
  "desk": "デスク",
  "cloud url": "クラウドurl",
  "cloud token": "クラウドトークン",
  "chrome extension token": "chrome拡張機能トークン",
  "brother scan folder": "brotherスキャンフォルダ",
  "start with windows": "windowsと同時に起動",
  "security": "セキュリティ",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "ログイン中のスマホ、タブレット、ブラウザをすべて（これも含めて）ログアウトします。端末をなくしたり、誰かに入られたと思ったら使ってね",
  "log out everywhere": "すべてからログアウト",
  "pick a look": "見た目を選ぶ",
  "background pattern": "背景パターン",
  "film grain and fog": "フィルムグレインと霧",
  "calm motion": "穏やかな動き",
  "retry": "再試行",
  "toss": "捨てる",
  "logs": "ログ",
  "paid on": "支払日",
  "undo": "元に戻す",
  "plan": "計画",
  "setup token": "セットアップトークン",
  "talk to chi": "chiと話す",
  "jot into inbox": "受信箱にメモ",
  "whose budget": "誰の予算",
  "what kind": "種類",
  "what it is": "内容",
  "ask chi…": "chiに聞く…",
  "ask": "聞く",
  "refresh": "更新",
  "find a task": "タスクを探す",
  "just type, it saves itself": "入力するだけで自動保存",
  "search notes": "メモを検索",
  "back": "戻る",
  "print": "印刷",
  "# heading\n\nmarkdown works, autosave is on": "# 見出し\n\nmarkdown対応、自動保存オン",
  "search refs, tags, characters": "資料・タグ・キャラを検索",
  "tile size": "タイルの大きさ",
  "add pictures": "画像を追加",
  "sort the feed": "フィードの並び",
  "what you want to remember about this": "これについて覚えておきたいこと",
  "re-index": "再インデックス",
  "open post": "投稿を開く",
  "message chi": "chiにメッセージ",
  "send": "送信",
  "a sketch a day…": "1日1枚スケッチ…",
  "how often": "頻度",
  "how many": "回数",
  "note, optional": "メモ（任意）",
  "nudge me about…": "知らせてほしいこと…",
  "kind": "種類",
  "set the time": "時間を設定",
  "minutes, like 40 or 1h30": "分数（例：40、1h30）",
  "reset": "リセット",
  "another tip": "別のヒント",
  "pick a colour": "色を選ぶ",
  "name, like sitting nsfw": "名前（例：座りnsfw）",
  "piece": "作品",
  "client (for the money stats)": "クライアント（お金の統計用）",
  "amount": "金額",
  "due": "期限",
  "what they want drawn": "描いてほしい内容",
  "previous month": "前の月",
  "next month": "次の月",
  "what is it": "何？",
  "owed": "残額",
  "category": "カテゴリ",
  "only refs matching… (optional)": "一致する資料のみ…（任意）",
  "add the characters from zirk.eu/oc": "zirk.eu/ocのキャラを追加",
  "add the characters from the discord character channel": "discordのキャラチャンネルからキャラを追加",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chiがキャラの画像を見て、タグと一言を書きます。キャラや資料選びが上手になります",
  "search name, race, likes, fetishes…": "名前・種族・好き・フェチで検索…",
  "search characters…": "キャラを検索…",
  "reload": "再読み込み",
  "add an event": "予定を追加",
  "map": "地図",
  "name it: studio, mum's, good parking": "名前：スタジオ、実家、良い駐車場",
  "a note, optional": "メモ（任意）",
  "colour": "色",
  "sushi, art supplies, an address": "寿司、画材、住所",
  "how far": "距離",
  "add a stop: address, postcode or place": "経由地を追加：住所、郵便番号、場所",
  "add stop": "経由地を追加",
  "download": "ダウンロード",
  "add the picture on your clipboard, or press ctrl+v": "クリップボードの画像を追加、またはctrl+v",
  "search title, artist, character, tag…": "タイトル・作者・キャラ・タグで検索…",
  "untitled": "無題",
  "type a name to add a character": "名前を入力してキャラを追加",
  "count a fap": "fapをカウント",
  "console.anthropic.com, api keys": "console.anthropic.com › apiキー",
  "the part after the domain": "ドメインの後ろの部分",
  "maps javascript, places (new) and routes": "maps javascript、places (new)、routes",
  "only if the map should load with its own key": "地図を専用キーで読み込む場合のみ",
  "dock": "ドック",
  "find a tool or place": "ツールや場所を探す",
  "what needs doing?": "やることは？",
  "optional notes": "メモ（任意）",
  "index": "インデックス",
  "mark done": "完了にする",
  "status": "状態",
  "link a task": "タスクをリンク",
  "find a plane or chix task": "planeかchixのタスクを探す",
  "take back the last one": "最後のを取り消す",
  "take out": "外す",
  "tasks": "タスク",
  "Today": "今日",
  "refs": "資料",
  "References": "資料",
  "feed": "フィード",
  "describe": "説明",
  "Ask ChiX": "ChiXに聞く",
  "gesture": "ジェスチャー",
  "Gesture drawing": "ジェスチャードローイング",
  "Session timer": "セッションタイマー",
  "palette": "パレット",
  "prompts": "プロンプト",
  "Commissions": "依頼",
  "ocs": "OC",
  "maps": "マップ",
  "calc": "電卓",
  "Calculator": "電卓",
  "doodles": "落書き",
  "scans": "スキャン",
  "Claude usage": "Claude利用状況",
  "people": "メンバー",
  "share": "共有",
  "setup": "設定",
  "keys": "キー",
  "themes": "テーマ",
  "studio": "スタジオ",
  "system": "システム",
  "Home": "ホーム",
  "Plan": "計画",
  "Studio": "スタジオ",
  "Practice": "練習",
  "Ledger": "帳簿",
  "Library": "ライブラリ",
  "Core": "コア",
  "language": "言語",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "あなただけの設定。アプリの表示とchiの返事がこの言語になります。選ぶとすぐ保存されます",
  "Quick note": "クイックメモ",
  "Reminders": "リマインダー",
  "Ubuntu helpers": "Ubuntuヘルパー",
  "Quit": "終了",
  "open {name}": "{name}を開く",
  "sort": "並べ替え",
  "this one is mine": "これは私の",
  "reverse the order": "順番を逆にする",
  "filter": "絞り込み",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name}がログインできるようになりました。chi、メモ、通知、ルーティン、目標から始まります",
  "no type": "種類なし",
  "new type": "新しい種類",
  "no price": "価格なし",
  "{n} open": "未払い{n}件",
  "settled": "精算済み",
  "{amount} owed": "{amount} 未払い",
  "{amount} credit": "{amount} のクレジット",
  "even": "差引なし",
  "take this back": "これを取り消す",
  "{paid} paid · {owed} still owed": "{paid} 支払済み · 残り {owed}",
  "{paid} paid, settled": "{paid} 支払済み、精算済み",
  "from credit": "クレジットから",
  "use {amount} credit": "{amount} のクレジットを使う",
  "pay {amount} in full": "{amount} を全額支払う",
  "{n} characters": "キャラ {n} 件",
  "{n} references": "資料 {n} 件",
  "take off": "外す",
  "{n} saved": "{n} 件保存",
  "default currency": "既定の通貨",
  "chi is looking...": "チィが見ています...",
  "let chi describe them": "チィに説明してもらう",
  "add a character": "キャラを追加",
  "{amount} is over what is owed. keep it as credit for {client}?": "{amount} は未払い額を超えています。{client} さんのクレジットとして預かりますか?",
  "payment added": "支払いを追加しました",
  "credit added": "クレジットを追加しました",
  "{owed} owed": "{owed} 未払い",
  "clients": "クライアント",
  "rates": "料金表",
  "pay": "支払う",
  "payment": "支払い",
  "use credit": "クレジットを使う",
  "add credit": "クレジットを追加",
  "owed to you": "受け取り待ち",
  "credit held": "預かりクレジット",
  "add starter set": "基本の種類を追加",
  "voice": "音声",
  "tune": "調整",
  "tune {name}": "{name}を調整",
  "items shown": "表示件数",
  "cozy": "ゆったり",
  "whole home: spacing": "ホーム全体：間隔",
  "whole home: columns (wide screens)": "ホーム全体：列数（広い画面）",
  "this browser can't listen, type here instead": "このブラウザは音声入力できません。ここに入力してください",
  "added to your inbox": "受信箱に追加しました",
  "saved as {name}": "{name}として保存しました",
  "sent to chi": "チーに送りました",
  "copied": "コピーしました",
  "open in notes": "ノートで開く",
  "no pings waiting": "待機中の通知はありません",
  "tap the mic and talk, or type": "マイクをタップして話すか、入力してください",
  "mic blocked": "マイクがブロックされています",
  "could not hear": "聞き取れませんでした",
  "dictate": "音声入力",
  "study": "勉強",
  "pin to home": "ホームにピン留め",
  "pinned to home, press to unpin": "ホームにピン留め済み。押すと外します",
  "pin {name} to home": "{name}をホームにピン留め",
  "unpin {name} from home": "{name}のピン留めを外す",
  "{count} pins is the limit, unpin one first": "ピン留めは{count}件までです。先に1つ外してください",
  "Tier lists": "ティアリスト",
  "new tier list": "新しいティアリスト",
  "no tier lists yet. make one, add pictures and rank them": "ティアリストはまだありません。作って、画像を追加してランク付けしましょう",
  "back to my tier lists": "自分のティアリストに戻る",
  "tier list title": "ティアリストのタイトル",
  "the link to this tier list": "このティアリストへのリンク",
  "stop sharing": "共有をやめる",
  "tiers": "ティア",
  "not ranked": "未分類",
  "pictures not ranked yet": "まだ分類していない画像",
  "add some pictures to start. drop them here, paste them, or pick them from your files": "画像を追加して始めましょう。ここにドロップ、貼り付け、またはファイルから選べます",
  "every picture is ranked": "すべての画像を分類済み",
  "the picked picture": "選んだ画像",
  "name of this picture": "この画像の名前",
  "name it": "名前をつける",
  "unrank": "分類を外す",
  "add tier": "ティアを追加",
  "put everything back": "すべて戻す",
  "save picture": "画像を保存",
  "delete list": "リストを削除",
  "tier": "ティア",
  "remove this tier": "このティアを削除",
  "pictures in a removed tier go back to the tray": "削除したティアの画像はトレイに戻ります",
  "ranked": "分類済み",
  "link on": "リンク有効",
  "could not load the tier lists": "ティアリストを読み込めませんでした",
  "could not make a tier list": "ティアリストを作れませんでした",
  "could not open that tier list": "そのティアリストを開けませんでした",
  "picture": "画像",
  "in tier {name}": "ティア {name} にあります",
  "in the unranked tray": "未分類トレイにあります",
  "place the picked picture in tier {name}": "選んだ画像をティア {name} に置く",
  "tier {name}, {count} pictures, press to change it": "ティア {name}、画像 {count} 枚、押して変更",
  "tier {name}": "ティア {name}",
  "move tier {name} up": "ティア {name} を上へ",
  "move tier {name} down": "ティア {name} を下へ",
  "tier {name} moved to row {row}": "ティア {name} を {row} 行目に移動しました",
  "now tap a tier to place it, or drag it there": "ティアをタップして置くか、そこへドラッグしてください",
  "drag a picture to a tier, or tap it and then tap the tier": "画像をティアにドラッグするか、画像をタップしてからティアをタップします",
  "position {n}": "{n} 番目",
  "tier removed, its pictures are back in the tray": "ティアを削除しました。画像はトレイに戻りました",
  "a tier list holds {count} pictures": "ティアリストには {count} 枚まで入ります",
  "those are not pictures": "画像ではありません",
  "adding pictures {done} of {total}": "画像を追加中 {done} / {total}",
  "{count} pictures added": "画像を {count} 枚追加しました",
  "could not add those": "追加できませんでした",
  "link": "リンク",
  "link is on, anyone who has it can look at this list": "リンクは有効です。リンクを知っている人はこのリストを見られます",
  "link is off": "リンクは無効です",
  "could not change the link": "リンクを変更できませんでした",
  "link copied": "リンクをコピーしました",
  "press copy on your keyboard to copy the link": "キーボードのコピーでリンクをコピーしてください",
  "every picture is back in the tray": "すべての画像をトレイに戻しました",
  "Music": "ミュージック",
  "car mode": "カーモード",
  "seek": "シーク",
  "previous song": "前の曲",
  "next song": "次の曲",
  "repeat off": "リピートなし",
  "repeat one song": "1曲リピート",
  "repeat everything": "全曲リピート",
  "volume": "音量",
  "vol": "音量",
  "library": "ライブラリ",
  "songs": "曲",
  "playlists": "プレイリスト",
  "new playlist": "新しいプレイリスト",
  "rename playlist": "プレイリスト名を変更",
  "paste a youtube link": "YouTubeのリンクを貼り付け",
  "get it": "取り込む",
  "upload mp3 or m4a files": "mp3 / m4a ファイルをアップロード",
  "youtube links are downloaded on the server into your own library. a playlist link brings every song, up to 40. files can also be dropped on this page": "YouTubeのリンクはサーバーであなた専用のライブラリにダウンロードされます。プレイリストのリンクは最大40曲まで取り込みます。ファイルをこのページにドロップすることもできます",
  "downloads": "ダウンロード",
  "search songs": "曲を検索",
  "back to playlists": "プレイリストに戻る",
  "rename or delete this playlist": "このプレイリストの名前変更・削除",
  "song": "曲",
  "change cover": "カバーを変更",
  "remove cover": "カバーを削除",
  "artist": "アーティスト",
  "album": "アルバム",
  "downloaded from youtube": "YouTubeからダウンロード",
  "delete this song": "この曲を削除",
  "delete playlist": "プレイリストを削除",
  "open the music player": "プレーヤーを開く",
  "could not load the music": "音楽を読み込めませんでした",
  "nothing playing": "再生中の曲なし",
  "unknown artist": "不明なアーティスト",
  "pick a song or add one": "曲を選ぶか追加してください",
  "details for {name}": "{name} の詳細",
  "{count} songs": "{count} 曲",
  "this playlist is empty. open a song's details to add it here": "このプレイリストは空です。曲の詳細を開いてここに追加します",
  "no playlists yet": "プレイリストはまだありません",
  "nothing matches that": "一致するものがありません",
  "no songs yet. add a youtube link or upload some files": "曲はまだありません。YouTubeのリンクを追加するか、ファイルをアップロードしてください",
  "could not get it": "取り込めませんでした",
  "downloading from youtube is not set up on this server yet. uploads work. whoever runs the server needs to install yt-dlp": "このサーバーではYouTubeのダウンロードがまだ設定されていません。アップロードは使えます。サーバー管理者がyt-dlpをインストールする必要があります",
  "that is not a youtube link": "YouTubeのリンクではありません",
  "added to the downloads": "ダウンロードに追加しました",
  "could not start that": "開始できませんでした",
  "use mp3, m4a, ogg, wav or flac files": "mp3、m4a、ogg、wav、flac ファイルを使ってください",
  "adding {done} of {total}: {name}": "追加中 {done} / {total}：{name}",
  "could not add it": "追加できませんでした",
  "{count} songs added": "{count} 曲を追加しました",
  "added to {name}": "{name} に追加しました",
  "taken out of {name}": "{name} から外しました",
  "could not change the cover": "カバーを変更できませんでした",
  "delete the playlist {name}? the songs stay in your library": "プレイリスト {name} を削除しますか？曲はライブラリに残ります",
  "all songs": "すべての曲",
  "shuffle everything": "すべてシャッフル",
  "could not play {name}": "{name} を再生できませんでした",
  "leaderboard": "ランキング",
  "medals": "メダル",
  "draw today": "今日の絵",
  "suggestions": "提案",
  "achievements": "実績",
  "points": "ポイント",
  "shine": "輝き",
  "rank": "順位",
  "ranks": "順位",
  "exercise": "練習",
  "draw a ref": "参考画像を描く",
  "another": "別のもの",
  "lesson": "レッスン",
  "other three": "別の3枚",
  "done, I drew it": "描いた",
  "drawn today, nice": "今日は描きました",
  "no references to pick from yet": "選べる参考画像がまだありません",
  "how could chix be better?": "チーをもっと良くするには？",
  "no suggestions yet, be the first": "まだ提案がありません。最初の1人になりましょう",
  "nobody has points yet": "まだ誰もポイントを持っていません",
  "earn points to win your first medal": "ポイントをためて最初のメダルを獲得しよう",
  "show me on the leaderboard": "ランキングに表示する",
  "of {n}": "{n}人中",
  "{done} of {total} achievements": "実績 {done} / {total}",
  "{n} points": "{n}ポイント",
  "{n} need a polish": "{n}個が汚れています",
  "all shining": "すべてピカピカ",
  "needs a polish": "磨く必要あり",
  "shining": "ピカピカ",
  "keep going to find out": "続けて見つけよう",
  "{n} min": "{n}分",
  "challenge done, {n} day streak": "チャレンジ達成、{n}日連続",
  "pick this reference": "この参考画像を選ぶ",
  "vote": "投票",
  "fewer": "少なく",
  "planned": "予定",
  "declined": "見送り",
  "achievement: {name} +{points}": "実績：{name} +{points}",
  "medal earned: {name}": "メダル獲得：{name}",
  "Upskill": "スキルアップ",
  "upskill": "スキルアップ",
  "medals gather grime every day. rub one with a finger or the mouse until it shines. a dirty medal adds less shine to your score": "メダルは毎日汚れていきます。指やマウスでこすってピカピカにしましょう。汚れたメダルはスコアに加わる輝きが減ります",
  "score is points plus shine, and shine is what your medals add while they are clean": "スコアはポイントと輝きの合計です。輝きは、きれいなメダルが加えてくれる分です",
  "music": "音楽",
  "calendar": "カレンダー",
  "session timer": "タイマー",
  "prompt": "お題",
  "calculator": "電卓",
  "doodle wall": "落書きの壁",
  "whiteboards": "ホワイトボード",
  "references": "参考資料",
  "characters": "キャラクター",
  "tier lists": "ティアリスト",
  "gesture drawing": "ジェスチャードローイング",
  "claude usage": "Claudeの使用量",
  "sharing": "共有",
  "{n} songs": "{n}曲",
  "tap play to shuffle your library": "再生を押すとライブラリをシャッフルします",
  "no colours saved yet": "保存した色はまだありません",
  "no prompts saved yet": "保存したお題はまだありません",
  "{owed} owed to you": "{owed}が未払い",
  "nobody owes you": "未払いはありません",
  "no open commissions": "進行中の依頼はありません",
  "calculate": "計算",
  "make a wheel in spin first": "まずスピンでホイールを作ってください",
  "no saved places yet": "保存した場所はまだありません",
  "no scans yet": "スキャンはまだありません",
  "the wall is empty": "壁は空です",
  "no whiteboards yet": "ホワイトボードはまだありません",
  "no references yet": "参考資料はまだありません",
  "no characters yet": "キャラクターはまだいません",
  "{ranked} of {count} ranked": "{count}件中{ranked}件を分類済み",
  "no tier lists yet": "ティアリストはまだありません",
  "5 × 30s": "5 × 30秒",
  "10 × 1m": "10 × 1分",
  "20 × 2m": "20 × 2分",
  "a warm up from the pose library, pick a length": "ポーズライブラリでウォームアップ、長さを選んでください",
  "{points} points · rank {rank}": "{points}ポイント · {rank}位",
  "nothing logged": "ログはありません",
  "of ${budget} this month": "今月 ${budget} 中",
  "up": "稼働",
  "nobody added yet": "まだ誰も追加されていません",
  "{out} things shared by you, {incoming} people share with you": "あなたが共有しているもの{out}件、あなたに共有している人{incoming}人",
  "your medals": "あなたのメダル",
  "change the drawing": "絵を変更",
  "add a screenshot or photo of your drawing": "絵のスクリーンショットか写真を追加",
  "your drawing": "あなたの絵",
  "a line about it (optional)": "ひとこと（任意）",
  "share on the feed, +{n} points": "フィードに共有 +{n}ポイント",
  "add your drawing first": "先に絵を追加してください",
  "finish without sharing": "共有せずに完了",
  "you drew today and shared it, nice": "今日描いて共有しました、すごい",
  "you can still share your drawing for +{n} points": "絵を共有すると+{n}ポイントもらえます",
  "worth +{done} points, and +{more} more when you share your drawing, plus any achievement it unlocks": "+{done}ポイント、絵を共有するとさらに+{more}ポイント、解除された実績の分も加わります",
  "add your drawing": "絵を追加",
  "drew a reference": "参考画像を描きました",
  "drew {title}": "{title}を描きました",
  "finished draw today with a reference": "参考画像で今日の絵を完了しました",
  "finished draw today: {title}": "今日の絵を完了：{title}",
  "unlocked {names}": "{names}を解除しました",
  "earned {names}": "{names}を獲得しました",
  "finished today's cards": "今日のカードを終えました",
  "{n} answered": "{n}問に回答",
  "open the drawing": "絵を開く",
  "the reference": "参考画像",
  "cheer": "応援",
  "drawings": "絵",
  "studying": "勉強",
  "my upskilling": "わたしのスキルアップ",
  "day streak": "連続日数",
  "answered today": "今日の回答",
  "start a language in upskill and it shows up here": "スキルアップで言語を始めるとここに表示されます",
  "{n} posts": "{n}件の投稿",
  "nothing on the feed yet, finish draw today or a day of cards": "フィードはまだ空です。今日の絵かカードを終えてみましょう",
  "nothing on the feed yet": "フィードはまだ空です",
  "upskilling feed": "スキルアップフィード",
  "Draw today": "今日の絵",
  "Feed": "フィード",
  "Modern Chinese": "現代中国語",
  "Classical Chinese": "文言（古典中国語）",
  "modern chinese words": "現代中国語の単語",
  "classical chinese words": "文言の単語",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. drawings you share show up on the feed": "毎日新しい練習、drawaboxのドリルや定番のウォームアップのスタイルです。参考画像を描くは共有ライブラリから3枚選べます。共有した絵はフィードに表示されます",
  "pick a length, draw the poses, then come back here and press done": "長さを選んでポーズを描き、ここに戻って完了を押してください",
  "session started today, {n} poses picked": "今日のセッション開始済み、{n}ポーズ選択",
  "no gesture session started today yet": "今日はまだジェスチャーセッションを始めていません",
  "start a gesture session first": "先にジェスチャーセッションを始めてください",
  "finished draw today with a gesture session": "ジェスチャーセッションで今日の絵を完了しました",
  "drew {n} gesture poses": "ジェスチャーポーズを{n}枚描きました",
  "a new exercise every day, in the style of the drawabox drills and other classic warm ups. draw a ref picks three references from the shared library to choose from. gesture starts a timed session from the pose library. drawings you share show up on the feed": "毎日新しい練習、drawaboxのドリルや定番のウォームアップのスタイルです。参考画像を描くは共有ライブラリから3枚選べます。ジェスチャーはポーズライブラリでタイマー付きセッションを始めます。共有した絵はフィードに表示されます",
  "open the reference": "参考画像を開く",
  "don't draw this one": "これは描かない",
  "draw this one": "これを描く",
  "picked": "選択済み",
  "pick": "選ぶ",
  "favorite": "お気に入り",
  "favorites": "お気に入り",
  "to do": "未着手",
  "doing": "進行中",
  "blocked": "保留中",
  "move to": "移動先",
  "status: {status}": "状態: {status}",
  "hidden here, still open in plane": "ここでは非表示、plane では未完了のまま",
  "sure?": "本当に?",
  "delete task": "タスクを削除",
  "hide task": "タスクを非表示",
  "hide the hidden": "非表示分を隠す",
  "show hidden ({count})": "非表示を表示 ({count})",
  "restore": "元に戻す",
  "nothing here": "ここには何もありません",
  "trash": "ゴミ箱",
  "tap the trash can on the card to delete it": "カードのゴミ箱をタップして削除",
  "set status": "状態を変更",
  "note (optional)": "メモ (任意)",
  "Linked calendars": "連携カレンダー",
  "Chi copies these in read only, one way. Changes made here never go back to them.": "Chi は読み取り専用で一方向にコピーします。ここでの変更は元のカレンダーには反映されません。",
  "Name": "名前",
  "Calendar link": "カレンダーのリンク",
  "Add calendar": "カレンダーを追加",
  "Adding": "追加中",
  "Proton: Settings, Calendars, Share via link (private). Google: Settings, your calendar, Secret address in iCal format. Apple: Calendar, share, Public calendar, copy link. Outlook: Settings, Shared calendars, Publish a calendar, ICS. Nextcloud: calendar menu, Copy private link.": "Proton: 設定、カレンダー、リンクで共有(非公開)。Google: 設定、カレンダー、iCal 形式の非公開アドレス。Apple: カレンダー、共有、公開カレンダー、リンクをコピー。Outlook: 設定、共有カレンダー、カレンダーの公開、ICS。Nextcloud: カレンダーのメニュー、非公開リンクをコピー。",
  "Let Chi see this calendar": "Chi にこのカレンダーを見せる",
  "Sync now": "今すぐ同期",
  "Syncing": "同期中",
  "Remove": "削除",
  "Tap again to remove": "もう一度タップで削除",
  "never synced": "未同期",
  "{count} min ago": "{count}分前",
  "{count} h ago": "{count}時間前",
  "{count} d ago": "{count}日前",
  "synced {when} · {count} events": "{when}に同期 · {count}件",
  "last good sync {when}": "最後の成功した同期 {when}",
  "could not sync": "同期できませんでした",
  "could not add that calendar": "そのカレンダーを追加できませんでした",
  "that does not look like a calendar link": "カレンダーのリンクではないようです",
  "calendar links must start with https:// or webcal://": "リンクは https:// か webcal:// で始まる必要があります",
  "that link has a login inside it, use the private share link instead": "そのリンクにはログイン情報が含まれています。非公開の共有リンクを使ってください",
  "that address is not allowed": "そのアドレスは使えません",
  "that calendar is too big (over 5 MB)": "そのカレンダーは大きすぎます(5MB超)",
  "that link did not give a calendar file": "そのリンクからカレンダーファイルを取得できませんでした",
  "the calendar server took too long": "カレンダーサーバーの応答が遅すぎます",
  "could not reach that calendar": "そのカレンダーに接続できません",
  "that calendar is already linked": "そのカレンダーはすでに連携済みです",
  "that is plenty of linked calendars, remove one first": "連携カレンダーが多すぎます。先に1つ削除してください",
  "too many redirects": "リダイレクトが多すぎます",
  "the calendar server sent a broken redirect": "カレンダーサーバーが不正なリダイレクトを返しました",
  "otherworld rust": "異世界のさび",
  "hospital green": "病院グリーン",
  "y2k aqua": "Y2Kアクア",
  "vhs blue": "VHSブルー",
  "paper zine": "紙のジン",
  "cassette": "カセット",
  "moonlit violet": "月明かりのバイオレット",
  "lime soda": "ライムソーダ",
  "rose quartz": "ローズクォーツ",
  "sepia archive": "セピアのアーカイブ",
  "deep sea lab": "深海ラボ",
  "arcade night": "アーケードナイト",
  "velvet room": "ベルベットの部屋",
  "boudoir": "ブドワール",
  "latex noir": "ラテックスノワール",
  "neon lounge": "ネオンラウンジ",
  "succubus": "サキュバス",
  "honey trap": "ハニートラップ",
  "cherry cola": "チェリーコーラ",
  "after hours": "アフターアワーズ",
  "peeling paint and a rusted siren": "はがれた塗装と錆びたサイレン",
  "flickering corridor light, sick green tile": "ちらつく廊下の灯りと病的な緑のタイル",
  "glossy bubble blue, 2001 desktop": "つやつやバブルブルー、2001年のデスクトップ",
  "tracking lines and a blue no signal screen": "トラッキングノイズと青い信号なし画面",
  "photocopied paper and red marker": "コピー用紙と赤いマーカー",
  "walkman amber, warm brown tape": "ウォークマンの琥珀色、温かい茶色のテープ",
  "a quiet night in lavender light": "ラベンダー色の光の静かな夜",
  "fizzy lime, bright sticker shop": "しゅわしゅわライム、明るいステッカーショップ",
  "pale pink stone and soft rose": "淡いピンクの石とやわらかなローズ",
  "old film stock and brown ink": "古いフィルムと茶色のインク",
  "bathyscaphe lights and bioluminescent teal": "潜水艇の灯りと生物発光のティール",
  "cabinet glow, hot pink and electric cyan": "筐体の光、ホットピンクとエレクトリックシアン",
  "wine velvet curtains and low red light": "ワイン色のベルベットのカーテンと低い赤い灯り",
  "dusty rose, silk and brass lamplight": "くすんだ薔薇色、絹、真鍮のランプの灯り",
  "wet black gloss and a red sliver": "濡れたような黒の光沢と赤い一筋",
  "magenta tubes in a smoky bar": "煙った酒場のマゼンタの管",
  "blood red, violet shadow, a wicked grin": "血の赤、紫の影、いたずらな笑み",
  "warm amber, sticky gold and candle smoke": "温かな琥珀、とろりと金色、ろうそくの煙",
  "dark fizz, cherry red, diner neon": "黒い炭酸、チェリーレッド、ダイナーのネオン",
  "midnight indigo and rose city lights": "真夜中のインディゴと薔薇色の街灯り",
  "otherworld": "異世界",
  "y2k": "Y2K",
  "mature": "大人向け",
  "basic": "ベーシック",
  "japanese": "和風",
  "horror": "ホラー",
  "Silkscreen titles over the pixel labels": "タイトルは Silkscreen、ラベルはピクセル",
  "Pixelify Sans, a chunky bitmap face": "Pixelify Sans、太めのビットマップ書体",
  "Share Tech Mono, a thin hud readout": "Share Tech Mono、細いHUD表示",
  "IBM Plex Mono, a tidy code face": "IBM Plex Mono、きれいなコード書体",
  "Major Mono Display titles, text in Space Mono": "タイトルは Major Mono Display、本文は Space Mono",
  "Audiowide titles over the original labels": "タイトルは Audiowide、ラベルはそのまま",
  "Chakra Petch, angular and techy": "Chakra Petch、角ばったテック風",
  "Unbounded titles, Lexend text": "タイトルは Unbounded、本文は Lexend",
  "Syne, wide and art gallery edgy": "Syne、幅広でギャラリー風",
  "Monoton titles, a neon sign outline": "タイトルは Monoton、ネオンサインの輪郭",
  "Bungee titles, shop sign letters": "タイトルは Bungee、店の看板の文字",
  "Righteous titles, a 70s poster face": "タイトルは Righteous、70年代のポスター書体",
  "Bebas Neue titles, tall and flat": "タイトルは Bebas Neue、縦長でフラット",
  "Pacifico titles, a surf shop script": "タイトルは Pacifico、サーフショップの筆記体",
  "Fraunces, a soft old style serif": "Fraunces、やわらかなオールドスタイルのセリフ",
  "Playfair Display, high contrast and elegant": "Playfair Display、高コントラストで上品",
  "Cormorant Garamond, a delicate book face": "Cormorant Garamond、繊細な書籍体",
  "Cinzel titles, carved roman capitals": "タイトルは Cinzel、刻まれたローマ大文字",
  "Permanent Marker titles, Gloria Hallelujah text": "タイトルは Permanent Marker、本文は Gloria Hallelujah",
  "Kalam, quick pen handwriting": "Kalam、さらさら書いたペンの手書き",
  "Dancing Script titles, Kalam text": "タイトルは Dancing Script、本文は Kalam",
  "Indie Flower, loopy and cheerful": "Indie Flower、くるくるして陽気",
  "Shadows Into Light, thin felt tip": "Shadows Into Light、細いフェルトペン",
  "Nunito, rounded and calm": "Nunito、丸くて落ち着いた書体",
  "Quicksand, light and round": "Quicksand、軽くて丸い",
  "Comfortaa, circles and soft curves": "Comfortaa、円とやわらかな曲線",
  "Baloo 2, plump and friendly": "Baloo 2、ふっくらして親しみやすい",
  "Lexend, wide open and easy to read": "Lexend、ゆったりして読みやすい",
  "Josefin Sans, vintage geometric": "Josefin Sans、ヴィンテージな幾何学書体",
  "Zen Maru Gothic, round gothic": "Zen Maru Gothic、丸ゴシック",
  "Yusei Magic, felt pen marker": "Yusei Magic、フェルトペンの文字",
  "Hachi Maru Pop, bubbly pop lettering": "Hachi Maru Pop、ぽっぷで楽しい文字",
  "Reggae One titles, heavy and loud": "タイトルは Reggae One、重くて目立つ",
  "Creepster titles, dripping horror": "タイトルは Creepster、滴るホラー",
  "Rubik Glitch titles, a broken signal": "タイトルは Rubik Glitch、壊れた信号",
  "panels and screen": "パネルと画面",
  "cursor": "カーソル",
  "panel style": "パネルの形",
  "screen filter": "画面フィルター",
  "mouse cursor": "マウスカーソル",
  "cursor pack": "カーソルセット",
  "filter strength": "フィルターの強さ",
  "adult themes and cursors": "大人向けのテーマとカーソル",
  "Adult themes and cursors, suggestive but never explicit. Off by default. Only affects your own screen.": "大人向けのテーマとカーソルです。ほのめかす程度で、露骨な表現はありません。初期設定はオフ。自分の画面だけに反映されます。",
  "adult options on": "大人向けオプションをオンにしました",
  "adult options off": "大人向けオプションをオフにしました",
  "bracket": "ブラケット",
  "double line": "二重線",
  "window": "ウィンドウ",
  "offset": "ずらし影",
  "stitched": "ステッチ",
  "no frame": "枠なし",
  "night vision": "暗視",
  "dream": "ゆめ",
  "grayscale": "白黒",
  "commission": "コミッション",
  "delete commission": "コミッションを削除",
  "Shared with me ({count})": "共有されたもの ({count})",
  "sponge": "スポンジ",
  "cloth": "クロス",
  "locked": "ロック中",
  "condition": "状態",
  "holo": "ホロ",
  "Special": "スペシャル",
  "Rusty": "さびている",
  "Tarnished": "くすんでいる",
  "Dull": "つやなし",
  "Clean": "きれい",
  "Mirror": "鏡面",
  "The Collection": "コレクション",
  "{n} of {total}": "{total}個中{n}個",
  "needs polish": "みがきが必要",
  "fully polished": "ぴかぴか",
  "a medal you have not found yet": "まだ見つけていないメダル",
  "Put back in the case": "ケースにもどす",
  "take the {tool}": "{tool}を持つ",
  "scrape off the rust": "さびをこすり落とす",
  "scrub off the grime": "よごれをこする",
  "polish it to a shine": "つやが出るまでみがく",
  "That is rust. Scrape it off with the brush first.": "これはさびです。まずブラシでこすり落として。",
  "That is grime. Scrub it off with the sponge first.": "これはよごれです。まずスポンジでこすって。",
  "Nothing left for the {tool}. Try the {next}.": "{tool}でやることはもうありません。{next}を試して。",
  "Rub the medal with the {tool}. Press space to scrub.": "{tool}でメダルをこすります。スペースキーでこすれます。",
  "every area of chix has its own shelf. tap a medal to take it to the workbench and clean it with the brush, the sponge and the cloth. a dirty medal adds less shine to your score": "chixのエリアごとに専用の棚があります。メダルをタップして作業台に運び、ブラシ、スポンジ、クロスできれいにしましょう。よごれたメダルはスコアのかがやきが少なくなります",
  "{count} new medals": "新しいメダル{count}個",
  "Earned for": "獲得した実績",
  "How to earn it": "入手方法",
  "Date": "日付",
  "Not earned yet": "未獲得",
  "{n} {area} points": "{area}ポイント{n}",
  "Close": "閉じる",
  "{n} medals": "メダル{n}個",
  "{n} shining": "ピカピカ{n}個",
  "{n} rusty": "錆び{n}個",
  "Bronze": "ブロンズ",
  "Silver": "シルバー",
  "Gold": "ゴールド",
  "Crystal": "クリスタル",
  "Money": "お金",
  "Menu": "メニュー",
  "menu": "メニュー",
  "stations": "ステーション",
  "go to…": "移動…",
  "places in {name}": "{name}の場所",
  "{count} places": "{count}件",
  "search every place": "すべての場所を検索",
  "skip to content": "本文へスキップ",
  "wall": "ウォール",
  "boards": "ボード",
  "moodboard": "ムードボード",
  "ref feed": "資料フィード",
  "today at a glance": "今日をひと目で",
  "what to do and when": "やることと予定",
  "make art, keep your world": "絵を描き、世界を整える",
  "get better every day": "毎日上達する",
  "commissions and budget": "依頼と予算",
  "small handy things": "ちょっと便利な道具",
  "run the app": "アプリの管理",
  "station tuner. tap for all stations, drag to tune, arrow keys to step": "ステーションチューナー。タップで一覧、ドラッグで選局、矢印キーで移動",
  "show tasks from": "表示するタスク",
  "plane tasks": "plane のタスク",
  "chix bot tasks": "chix ボットのタスク",
  "commission tasks": "依頼のタスク",
  "on chosen weekdays": "選んだ曜日",
  "a few times a week": "週に数回",
  "when": "いつ",
  "just once": "1回だけ",
  "every week": "毎週",
  "type": "種類",
  "blend mode": "描画モード",
  "darkening": "暗くする",
  "lightening": "明るくする",
  "compare": "比較",
  "what to be pinged about": "何を通知するか",
  "routine name": "ルーティン名",
  "note title": "メモのタイトル",
  "note body": "メモの本文",
  "task name": "タスク名",
  "event title": "予定のタイトル",
  "piece name": "作品名",
  "client": "依頼主",
  "price": "価格",
  "images": "画像",
  "audio files": "音声ファイル",
  "cover image": "カバー画像",
  "joined Chi. say hi!": "Chiに参加しました。声をかけよう！",
  "started a shared whiteboard: {title}": "共有ホワイトボードを作成: {title}",
  "made a tier list public: {title}": "ティアリストを公開: {title}",
  "joined": "参加",
  "medal": "メダル",
  "art": "アート",
  "open the picture": "画像を開く",
  "comments": "コメント",
  "comment": "コメント",
  "write a comment": "コメントを書く",
  "edit post": "投稿を編集",
  "delete your post? it goes for everyone": "投稿を削除しますか？全員から消えます",
  "delete {name}'s post? it goes for everyone": "{name}の投稿を削除しますか？全員から消えます",
  "posts": "投稿",
  "events": "出来事",
  "nothing on the feed yet. post the first one": "まだ何もありません。最初の投稿をしよう",
  "post to the feed": "フィードに投稿",
  "write a post": "投稿を書く",
  "couldn't open that picture": "その画像を開けませんでした",
  "a picture needs to be a png, jpeg, webp or gif": "画像はpng、jpeg、webp、gifのいずれかにしてください",
  "that post is gone": "その投稿はもうありません",
  "you can only edit your own posts": "編集できるのは自分の投稿だけです",
  "that isn't yours to remove": "それはあなたが削除できません",
  "this post has enough comments": "この投稿にはもう十分なコメントがあります",
  "couldn't remove that": "削除できませんでした",
  "board name": "ボード名",
  "sure? tap again": "本当に？もう一度タップ",
  "{name}, plane project": "{name}（planeプロジェクト）",
  "rename or delete {name}": "{name}の名前変更・削除",
  "{count} tasks on this board. Deleting the board moves them to {inbox}.": "このボードのタスクは{count}件。削除すると{inbox}に戻ります。",
  "board deleted, its tasks are back in {inbox}": "ボードを削除しました。タスクは{inbox}に戻りました"
};
